/* tslint:disable */
/* eslint-disable */
/**
 * LMS API
 * API for the Timedright Learning Management Service
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface BaseModule
 */
export interface BaseModule {
    /**
     * Primary key
     * @type {string}
     * @memberof BaseModule
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseModule
     */
    'name'?: string;
    /**
     * Human readable identifier to display for this Part.
     * @type {string}
     * @memberof BaseModule
     */
    'identifier'?: string;
    /**
     * Optionally rich-text
     * @type {string}
     * @memberof BaseModule
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof BaseModule
     */
    'credits'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BaseModule
     */
    'sendCertificate'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseModule
     */
    'speakers'?: Array<string>;
    /**
     * 0-based order of this Module within it\'s Program
     * @type {number}
     * @memberof BaseModule
     */
    'orderIndex'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseModule
     */
    'publishDateStart'?: string | null;
}
/**
 * 
 * @export
 * @interface BasePart
 */
export interface BasePart {
    /**
     * Primary key
     * @type {string}
     * @memberof BasePart
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BasePart
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BasePart
     */
    'description'?: string;
    /**
     * Human readable identifier to display for this Part.
     * @type {string}
     * @memberof BasePart
     */
    'identifier'?: string;
    /**
     * 
     * @type {number}
     * @memberof BasePart
     */
    'credits'?: number;
    /**
     * 
     * @type {string}
     * @memberof BasePart
     * @deprecated
     */
    'sendCertificateDateStart'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BasePart
     */
    'speakers'?: Array<string>;
    /**
     * 0-based order of this Part within it\'s Module
     * @type {number}
     * @memberof BasePart
     */
    'orderIndex'?: number;
}
/**
 * 
 * @export
 * @interface BaseProgram
 */
export interface BaseProgram {
    /**
     * Primary key
     * @type {string}
     * @memberof BaseProgram
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseProgram
     */
    'name'?: string;
    /**
     * Human readable identifier to display for this Part.
     * @type {string}
     * @memberof BaseProgram
     */
    'identifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseProgram
     */
    'description'?: string;
    /**
     * 
     * @type {Location}
     * @memberof BaseProgram
     */
    'location'?: Location;
    /**
     * 
     * @type {string}
     * @memberof BaseProgram
     */
    'publishDateStart'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BaseProgram
     */
    'publishDateEnd'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BaseProgram
     */
    'showAccreditedBadge'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BaseProgram
     */
    'credits'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseProgram
     */
    'certificateText'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BaseProgram
     */
    'sendCertificate'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseProgram
     */
    'speakers'?: Array<string>;
    /**
     * 
     * @type {CertificateLocale}
     * @memberof BaseProgram
     */
    'certificateLocale'?: CertificateLocale;
}
/**
 * 
 * @export
 * @interface BaseStep
 */
export interface BaseStep {
    /**
     * Primary key
     * @type {string}
     * @memberof BaseStep
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseStep
     */
    'name'?: string;
    /**
     * Human readable identifier to display for this Step.
     * @type {string}
     * @memberof BaseStep
     */
    'identifier'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseStep
     */
    'speakers'?: Array<string>;
    /**
     * 0-based order of this Step within it\'s Part
     * @type {number}
     * @memberof BaseStep
     */
    'orderIndex'?: number;
    /**
     * 
     * @type {StepContent}
     * @memberof BaseStep
     */
    'content'?: StepContent;
}
/**
 * 
 * @export
 * @interface BaseSurvey
 */
export interface BaseSurvey {
    /**
     * Primary key
     * @type {string}
     * @memberof BaseSurvey
     */
    'id'?: string;
    /**
     * A JSON blob containing the survey template
     * @type {string}
     * @memberof BaseSurvey
     */
    'surveyContent'?: string;
}
/**
 * 
 * @export
 * @interface BaseUserResponse
 */
export interface BaseUserResponse {
    /**
     * A JSON blob containing a survey response for the current user if one exists
     * @type {string}
     * @memberof BaseUserResponse
     */
    'answersContent': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum CertificateLocale {
    FrCa = 'fr-CA',
    EnCa = 'en-CA'
}

/**
 * A program response with nested modules, parts, and steps
 * @export
 * @interface FullProgramResponse
 */
export interface FullProgramResponse {
    /**
     * Primary key
     * @type {string}
     * @memberof FullProgramResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FullProgramResponse
     */
    'name': string;
    /**
     * Human readable identifier to display for this Part.
     * @type {string}
     * @memberof FullProgramResponse
     */
    'identifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof FullProgramResponse
     */
    'description': string;
    /**
     * 
     * @type {Location}
     * @memberof FullProgramResponse
     */
    'location': Location;
    /**
     * 
     * @type {string}
     * @memberof FullProgramResponse
     */
    'publishDateStart': string | null;
    /**
     * 
     * @type {string}
     * @memberof FullProgramResponse
     */
    'publishDateEnd': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FullProgramResponse
     */
    'showAccreditedBadge': boolean;
    /**
     * 
     * @type {number}
     * @memberof FullProgramResponse
     */
    'credits': number;
    /**
     * 
     * @type {string}
     * @memberof FullProgramResponse
     */
    'certificateText': string;
    /**
     * 
     * @type {boolean}
     * @memberof FullProgramResponse
     */
    'sendCertificate': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof FullProgramResponse
     */
    'speakers': Array<string>;
    /**
     * 
     * @type {CertificateLocale}
     * @memberof FullProgramResponse
     */
    'certificateLocale': CertificateLocale;
    /**
     * 
     * @type {StepCompletion}
     * @memberof FullProgramResponse
     */
    'stepCompletion': StepCompletion;
    /**
     * This will be `null` if `sendCertificate` is false, or if there are no modules
     * @type {string}
     * @memberof FullProgramResponse
     */
    'sendCertificateDateStart': string | null;
    /**
     * 
     * @type {number}
     * @memberof FullProgramResponse
     */
    'totalCredits': number;
    /**
     * 
     * @type {string}
     * @memberof FullProgramResponse
     */
    'dateCreated': string;
    /**
     * 
     * @type {string}
     * @memberof FullProgramResponse
     */
    'dateModified': string;
    /**
     * 
     * @type {Array<ModuleResponse>}
     * @memberof FullProgramResponse
     */
    'modules': Array<ModuleResponse>;
}
/**
 * 
 * @export
 * @interface FullProgramResponseAllOf
 */
export interface FullProgramResponseAllOf {
    /**
     * 
     * @type {Array<ModuleResponse>}
     * @memberof FullProgramResponseAllOf
     */
    'modules'?: Array<ModuleResponse>;
}
/**
 * 
 * @export
 * @interface Location
 */
export interface Location {
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'street1'?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'street2'?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'city'?: string;
    /**
     * An ISO 3166 region short code (eg \"AB\" for \"Alberta\")
     * @type {string}
     * @memberof Location
     */
    'provStateRegion'?: string;
    /**
     * An ISO 3166-1 alpha-2 country short code (eg \"CA\" for \"Canada\")
     * @type {string}
     * @memberof Location
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'postalCode'?: string;
}
/**
 * 
 * @export
 * @interface ModuleResponse
 */
export interface ModuleResponse {
    /**
     * Primary key
     * @type {string}
     * @memberof ModuleResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ModuleResponse
     */
    'name': string;
    /**
     * Human readable identifier to display for this Part.
     * @type {string}
     * @memberof ModuleResponse
     */
    'identifier'?: string;
    /**
     * Optionally rich-text
     * @type {string}
     * @memberof ModuleResponse
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof ModuleResponse
     */
    'credits': number;
    /**
     * 
     * @type {boolean}
     * @memberof ModuleResponse
     */
    'sendCertificate': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ModuleResponse
     */
    'speakers': Array<string>;
    /**
     * 0-based order of this Module within it\'s Program
     * @type {number}
     * @memberof ModuleResponse
     */
    'orderIndex': number;
    /**
     * 
     * @type {string}
     * @memberof ModuleResponse
     */
    'publishDateStart': string | null;
    /**
     * 
     * @type {Array<PartResponse>}
     * @memberof ModuleResponse
     */
    'parts': Array<PartResponse>;
    /**
     * 
     * @type {string}
     * @memberof ModuleResponse
     */
    'dateCreated': string;
    /**
     * 
     * @type {string}
     * @memberof ModuleResponse
     */
    'dateModified': string;
    /**
     * 
     * @type {string}
     * @memberof ModuleResponse
     */
    'sendCertificateDateStart': string | null;
}
/**
 * 
 * @export
 * @interface ModuleResponseAllOf
 */
export interface ModuleResponseAllOf {
    /**
     * 
     * @type {Array<PartResponse>}
     * @memberof ModuleResponseAllOf
     */
    'parts'?: Array<PartResponse>;
    /**
     * 
     * @type {string}
     * @memberof ModuleResponseAllOf
     */
    'dateCreated'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModuleResponseAllOf
     */
    'dateModified'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModuleResponseAllOf
     */
    'sendCertificateDateStart'?: string | null;
}
/**
 * 
 * @export
 * @interface OrderingRequestItem
 */
export interface OrderingRequestItem {
    /**
     * Primary key
     * @type {string}
     * @memberof OrderingRequestItem
     */
    'id': string;
    /**
     * 0-based order of this item within its parent
     * @type {number}
     * @memberof OrderingRequestItem
     */
    'orderIndex': number;
}
/**
 * 
 * @export
 * @interface PartResponse
 */
export interface PartResponse {
    /**
     * Primary key
     * @type {string}
     * @memberof PartResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PartResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PartResponse
     */
    'description': string;
    /**
     * Human readable identifier to display for this Part.
     * @type {string}
     * @memberof PartResponse
     */
    'identifier'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartResponse
     */
    'credits': number;
    /**
     * 
     * @type {string}
     * @memberof PartResponse
     * @deprecated
     */
    'sendCertificateDateStart': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PartResponse
     */
    'speakers': Array<string>;
    /**
     * 0-based order of this Part within it\'s Module
     * @type {number}
     * @memberof PartResponse
     */
    'orderIndex': number;
    /**
     * 
     * @type {Array<StepResponse>}
     * @memberof PartResponse
     */
    'steps': Array<StepResponse>;
    /**
     * 
     * @type {string}
     * @memberof PartResponse
     */
    'dateCreated': string;
    /**
     * 
     * @type {string}
     * @memberof PartResponse
     */
    'dateModified': string;
}
/**
 * 
 * @export
 * @interface PartResponseAllOf
 */
export interface PartResponseAllOf {
    /**
     * 
     * @type {Array<StepResponse>}
     * @memberof PartResponseAllOf
     */
    'steps'?: Array<StepResponse>;
    /**
     * 
     * @type {string}
     * @memberof PartResponseAllOf
     */
    'dateCreated'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartResponseAllOf
     */
    'dateModified'?: string;
}
/**
 * 
 * @export
 * @interface Progress
 */
export interface Progress {
    /**
     * 
     * @type {string}
     * @memberof Progress
     */
    'dateStarted'?: string;
    /**
     * 
     * @type {string}
     * @memberof Progress
     */
    'dateCompleted'?: string;
}
/**
 * A program response without any deep nesting
 * @export
 * @interface SimpleProgramResponse
 */
export interface SimpleProgramResponse {
    /**
     * Primary key
     * @type {string}
     * @memberof SimpleProgramResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SimpleProgramResponse
     */
    'name': string;
    /**
     * Human readable identifier to display for this Part.
     * @type {string}
     * @memberof SimpleProgramResponse
     */
    'identifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleProgramResponse
     */
    'description': string;
    /**
     * 
     * @type {Location}
     * @memberof SimpleProgramResponse
     */
    'location': Location;
    /**
     * 
     * @type {string}
     * @memberof SimpleProgramResponse
     */
    'publishDateStart': string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleProgramResponse
     */
    'publishDateEnd': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SimpleProgramResponse
     */
    'showAccreditedBadge': boolean;
    /**
     * 
     * @type {number}
     * @memberof SimpleProgramResponse
     */
    'credits': number;
    /**
     * 
     * @type {string}
     * @memberof SimpleProgramResponse
     */
    'certificateText': string;
    /**
     * 
     * @type {boolean}
     * @memberof SimpleProgramResponse
     */
    'sendCertificate': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof SimpleProgramResponse
     */
    'speakers': Array<string>;
    /**
     * 
     * @type {CertificateLocale}
     * @memberof SimpleProgramResponse
     */
    'certificateLocale': CertificateLocale;
    /**
     * 
     * @type {StepCompletion}
     * @memberof SimpleProgramResponse
     */
    'stepCompletion': StepCompletion;
    /**
     * This will be `null` if `sendCertificate` is false, or if there are no modules
     * @type {string}
     * @memberof SimpleProgramResponse
     */
    'sendCertificateDateStart': string | null;
    /**
     * 
     * @type {number}
     * @memberof SimpleProgramResponse
     */
    'totalCredits': number;
    /**
     * 
     * @type {string}
     * @memberof SimpleProgramResponse
     */
    'dateCreated': string;
    /**
     * 
     * @type {string}
     * @memberof SimpleProgramResponse
     */
    'dateModified': string;
}
/**
 * 
 * @export
 * @interface SimpleProgramResponseAllOf
 */
export interface SimpleProgramResponseAllOf {
    /**
     * 
     * @type {StepCompletion}
     * @memberof SimpleProgramResponseAllOf
     */
    'stepCompletion'?: StepCompletion;
    /**
     * This will be `null` if `sendCertificate` is false, or if there are no modules
     * @type {string}
     * @memberof SimpleProgramResponseAllOf
     */
    'sendCertificateDateStart'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SimpleProgramResponseAllOf
     */
    'totalCredits'?: number;
    /**
     * 
     * @type {string}
     * @memberof SimpleProgramResponseAllOf
     */
    'dateCreated'?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleProgramResponseAllOf
     */
    'dateModified'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum StepAction {
    Complete = 'COMPLETE'
}

/**
 * 
 * @export
 * @interface StepActionRequest
 */
export interface StepActionRequest {
    /**
     * 
     * @type {StepAction}
     * @memberof StepActionRequest
     */
    'action'?: StepAction;
}
/**
 * 
 * @export
 * @interface StepCompletion
 */
export interface StepCompletion {
    /**
     * 
     * @type {number}
     * @memberof StepCompletion
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof StepCompletion
     */
    'completed': number;
    /**
     * 
     * @type {string}
     * @memberof StepCompletion
     */
    'lastAction': string;
}
/**
 * 
 * @export
 * @interface StepContent
 */
export interface StepContent {
    /**
     * 
     * @type {string}
     * @memberof StepContent
     */
    'type': StepContentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof StepContent
     */
    'id': string;
}

/**
    * @export
    * @enum {string}
    */
export enum StepContentTypeEnum {
    Survey = 'SURVEY',
    Youtube = 'YOUTUBE',
    Vimeo = 'VIMEO'
}

/**
 * 
 * @export
 * @interface StepResponse
 */
export interface StepResponse {
    /**
     * Primary key
     * @type {string}
     * @memberof StepResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof StepResponse
     */
    'name': string;
    /**
     * Human readable identifier to display for this Step.
     * @type {string}
     * @memberof StepResponse
     */
    'identifier'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StepResponse
     */
    'speakers': Array<string>;
    /**
     * 0-based order of this Step within it\'s Part
     * @type {number}
     * @memberof StepResponse
     */
    'orderIndex': number;
    /**
     * 
     * @type {StepContent}
     * @memberof StepResponse
     */
    'content': StepContent;
    /**
     * 
     * @type {Progress}
     * @memberof StepResponse
     */
    'progress': Progress;
    /**
     * 
     * @type {string}
     * @memberof StepResponse
     */
    'dateCreated': string;
    /**
     * 
     * @type {string}
     * @memberof StepResponse
     */
    'dateModified': string;
}
/**
 * 
 * @export
 * @interface StepResponseAllOf
 */
export interface StepResponseAllOf {
    /**
     * 
     * @type {Progress}
     * @memberof StepResponseAllOf
     */
    'progress'?: Progress;
    /**
     * 
     * @type {string}
     * @memberof StepResponseAllOf
     */
    'dateCreated'?: string;
    /**
     * 
     * @type {string}
     * @memberof StepResponseAllOf
     */
    'dateModified'?: string;
}
/**
 * 
 * @export
 * @interface SurveyAnswersResponse
 */
export interface SurveyAnswersResponse {
    /**
     * A JSON blob containing a survey response for the current user if one exists
     * @type {string}
     * @memberof SurveyAnswersResponse
     */
    'answersContent': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyAnswersResponse
     */
    'dateCreated': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyAnswersResponse
     */
    'dateModified': string;
    /**
     * A JSON blob containing the original survey
     * @type {string}
     * @memberof SurveyAnswersResponse
     */
    'originalSurveyContent': string;
}
/**
 * 
 * @export
 * @interface SurveyAnswersResponseAllOf
 */
export interface SurveyAnswersResponseAllOf {
    /**
     * 
     * @type {string}
     * @memberof SurveyAnswersResponseAllOf
     */
    'dateCreated'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyAnswersResponseAllOf
     */
    'dateModified'?: string;
    /**
     * A JSON blob containing the original survey
     * @type {string}
     * @memberof SurveyAnswersResponseAllOf
     */
    'originalSurveyContent'?: string;
}
/**
 * 
 * @export
 * @interface SurveyResponse
 */
export interface SurveyResponse {
    /**
     * Primary key
     * @type {string}
     * @memberof SurveyResponse
     */
    'id': string;
    /**
     * A JSON blob containing the survey template
     * @type {string}
     * @memberof SurveyResponse
     */
    'surveyContent': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyResponse
     */
    'dateCreated': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyResponse
     */
    'dateModified': string;
    /**
     * 
     * @type {SurveyAnswersResponse}
     * @memberof SurveyResponse
     */
    'userResponse'?: SurveyAnswersResponse;
}
/**
 * 
 * @export
 * @interface SurveyResponseAllOf
 */
export interface SurveyResponseAllOf {
    /**
     * 
     * @type {string}
     * @memberof SurveyResponseAllOf
     */
    'dateCreated'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyResponseAllOf
     */
    'dateModified'?: string;
    /**
     * 
     * @type {SurveyAnswersResponse}
     * @memberof SurveyResponseAllOf
     */
    'userResponse'?: SurveyAnswersResponse;
}
/**
 * 
 * @export
 * @interface UpsertModuleRequest
 */
export interface UpsertModuleRequest {
    /**
     * Primary key
     * @type {string}
     * @memberof UpsertModuleRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertModuleRequest
     */
    'name'?: string;
    /**
     * Human readable identifier to display for this Part.
     * @type {string}
     * @memberof UpsertModuleRequest
     */
    'identifier'?: string;
    /**
     * Optionally rich-text
     * @type {string}
     * @memberof UpsertModuleRequest
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpsertModuleRequest
     */
    'credits'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertModuleRequest
     */
    'sendCertificate'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpsertModuleRequest
     */
    'speakers'?: Array<string>;
    /**
     * 0-based order of this Module within it\'s Program
     * @type {number}
     * @memberof UpsertModuleRequest
     */
    'orderIndex'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpsertModuleRequest
     */
    'publishDateStart'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertModuleRequest
     * @deprecated
     */
    'sendCertificateDateStart'?: string | null;
}
/**
 * 
 * @export
 * @interface UpsertPartRequest
 */
export interface UpsertPartRequest {
    /**
     * Primary key
     * @type {string}
     * @memberof UpsertPartRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertPartRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertPartRequest
     */
    'description'?: string;
    /**
     * Human readable identifier to display for this Part.
     * @type {string}
     * @memberof UpsertPartRequest
     */
    'identifier'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpsertPartRequest
     */
    'credits'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpsertPartRequest
     * @deprecated
     */
    'sendCertificateDateStart'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpsertPartRequest
     */
    'speakers'?: Array<string>;
    /**
     * 0-based order of this Part within it\'s Module
     * @type {number}
     * @memberof UpsertPartRequest
     */
    'orderIndex'?: number;
}
/**
 * 
 * @export
 * @interface UpsertProgramRequest
 */
export interface UpsertProgramRequest {
    /**
     * Primary key
     * @type {string}
     * @memberof UpsertProgramRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertProgramRequest
     */
    'name'?: string;
    /**
     * Human readable identifier to display for this Part.
     * @type {string}
     * @memberof UpsertProgramRequest
     */
    'identifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertProgramRequest
     */
    'description'?: string;
    /**
     * 
     * @type {Location}
     * @memberof UpsertProgramRequest
     */
    'location'?: Location;
    /**
     * 
     * @type {string}
     * @memberof UpsertProgramRequest
     */
    'publishDateStart'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertProgramRequest
     */
    'publishDateEnd'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertProgramRequest
     */
    'showAccreditedBadge'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpsertProgramRequest
     */
    'credits'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpsertProgramRequest
     */
    'certificateText'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertProgramRequest
     */
    'sendCertificate'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpsertProgramRequest
     */
    'speakers'?: Array<string>;
    /**
     * 
     * @type {CertificateLocale}
     * @memberof UpsertProgramRequest
     */
    'certificateLocale'?: CertificateLocale;
    /**
     * 
     * @type {string}
     * @memberof UpsertProgramRequest
     * @deprecated
     */
    'sendCertificateDateStart'?: string | null;
}
/**
 * 
 * @export
 * @interface UpsertProgramRequestAllOf
 */
export interface UpsertProgramRequestAllOf {
    /**
     * 
     * @type {string}
     * @memberof UpsertProgramRequestAllOf
     * @deprecated
     */
    'sendCertificateDateStart'?: string | null;
}
/**
 * 
 * @export
 * @interface UpsertStepRequest
 */
export interface UpsertStepRequest {
    /**
     * Primary key
     * @type {string}
     * @memberof UpsertStepRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertStepRequest
     */
    'name'?: string;
    /**
     * Human readable identifier to display for this Step.
     * @type {string}
     * @memberof UpsertStepRequest
     */
    'identifier'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpsertStepRequest
     */
    'speakers'?: Array<string>;
    /**
     * 0-based order of this Step within it\'s Part
     * @type {number}
     * @memberof UpsertStepRequest
     */
    'orderIndex'?: number;
    /**
     * 
     * @type {StepContent}
     * @memberof UpsertStepRequest
     */
    'content'?: StepContent;
}
/**
 * 
 * @export
 * @interface UpsertSurveyAnswersRequest
 */
export interface UpsertSurveyAnswersRequest {
    /**
     * A JSON blob containing a survey response for the current user if one exists
     * @type {string}
     * @memberof UpsertSurveyAnswersRequest
     */
    'answersContent': string;
}
/**
 * 
 * @export
 * @interface UpsertSurveyRequest
 */
export interface UpsertSurveyRequest {
    /**
     * Primary key
     * @type {string}
     * @memberof UpsertSurveyRequest
     */
    'id'?: string;
    /**
     * A JSON blob containing the survey template
     * @type {string}
     * @memberof UpsertSurveyRequest
     */
    'surveyContent': string;
}
/**
 * Additional user-specific metadata for a program
 * @export
 * @interface UserProgramMetadata
 */
export interface UserProgramMetadata {
    /**
     * 
     * @type {string}
     * @memberof UserProgramMetadata
     */
    'dateStarted': string;
    /**
     * 
     * @type {string}
     * @memberof UserProgramMetadata
     */
    'dateCompleted': string;
}
/**
 * A program with additional data about its group
 * @export
 * @interface UserStartedProgramResponse
 */
export interface UserStartedProgramResponse {
    /**
     * 
     * @type {string}
     * @memberof UserStartedProgramResponse
     */
    'groupId': string;
    /**
     * 
     * @type {SimpleProgramResponse}
     * @memberof UserStartedProgramResponse
     */
    'program': SimpleProgramResponse;
    /**
     * 
     * @type {UserProgramMetadata}
     * @memberof UserStartedProgramResponse
     */
    'metadata': UserProgramMetadata;
}

/**
 * AdministrativeAPIsApi - axios parameter creator
 * @export
 */
export const AdministrativeAPIsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns the details of a given Program, including the full hierarchy of dependent objects. This includes both published and unpublished Programs and Modules 
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFetchProgramById: async (programUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programUuid' is not null or undefined
            assertParamExists('adminFetchProgramById', 'programUuid', programUuid)
            const localVarPath = `/admin/programs/{program-uuid}`
                .replace(`{${"program-uuid"}}`, encodeURIComponent(String(programUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return a summary list of Programs the authorized user has access to. This includes unpublished programs.
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListProgramsForGroup: async (hashedGroupId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hashedGroupId' is not null or undefined
            assertParamExists('adminListProgramsForGroup', 'hashedGroupId', hashedGroupId)
            const localVarPath = `/admin/programs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (hashedGroupId !== undefined) {
                localVarQueryParameter['hashedGroupId'] = hashedGroupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a given Module. This will also cascade deletion of any dependent objects.
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteModule: async (moduleUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleUuid' is not null or undefined
            assertParamExists('deleteModule', 'moduleUuid', moduleUuid)
            const localVarPath = `/modules/{module-uuid}`
                .replace(`{${"module-uuid"}}`, encodeURIComponent(String(moduleUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a given Part. This will also cascade deletion of any dependent objects.
         * @param {string} partUuid UUID of the Part
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePart: async (partUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partUuid' is not null or undefined
            assertParamExists('deletePart', 'partUuid', partUuid)
            const localVarPath = `/parts/{part-uuid}`
                .replace(`{${"part-uuid"}}`, encodeURIComponent(String(partUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a given Program. This will also cascade deletion of any dependent objects.
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProgramById: async (programUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programUuid' is not null or undefined
            assertParamExists('deleteProgramById', 'programUuid', programUuid)
            const localVarPath = `/admin/programs/{program-uuid}`
                .replace(`{${"program-uuid"}}`, encodeURIComponent(String(programUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a given Step
         * @param {string} stepUuid UUID of the Step
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStep: async (stepUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepUuid' is not null or undefined
            assertParamExists('deleteStep', 'stepUuid', stepUuid)
            const localVarPath = `/steps/{step-uuid}`
                .replace(`{${"step-uuid"}}`, encodeURIComponent(String(stepUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a given survey. This is not allowed if there are surveyResponse objects linked to it.
         * @param {string} surveyUuid UUID of the survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurveyById: async (surveyUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyUuid' is not null or undefined
            assertParamExists('deleteSurveyById', 'surveyUuid', surveyUuid)
            const localVarPath = `/surveys/{survey-uuid}`
                .replace(`{${"survey-uuid"}}`, encodeURIComponent(String(surveyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return a Module, including the full hierarchy of dependent objects.
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModule: async (moduleUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleUuid' is not null or undefined
            assertParamExists('getModule', 'moduleUuid', moduleUuid)
            const localVarPath = `/modules/{module-uuid}`
                .replace(`{${"module-uuid"}}`, encodeURIComponent(String(moduleUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a summary list of Modules under a given Program.
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModulesByProgramId: async (programUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programUuid' is not null or undefined
            assertParamExists('getModulesByProgramId', 'programUuid', programUuid)
            const localVarPath = `/programs/{program-uuid}/modules`
                .replace(`{${"program-uuid"}}`, encodeURIComponent(String(programUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return a Part, including the full hierarchy of steps it contains.
         * @param {string} partUuid UUID of the Part
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPart: async (partUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partUuid' is not null or undefined
            assertParamExists('getPart', 'partUuid', partUuid)
            const localVarPath = `/parts/{part-uuid}`
                .replace(`{${"part-uuid"}}`, encodeURIComponent(String(partUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return a summary list of Parts under a Module.
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartsForModule: async (moduleUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleUuid' is not null or undefined
            assertParamExists('getPartsForModule', 'moduleUuid', moduleUuid)
            const localVarPath = `/modules/{module-uuid}/parts`
                .replace(`{${"module-uuid"}}`, encodeURIComponent(String(moduleUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all responses for a survey
         * @param {string} surveyUuid UUID of the survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSurveyResponsesForSurvey: async (surveyUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyUuid' is not null or undefined
            assertParamExists('listSurveyResponsesForSurvey', 'surveyUuid', surveyUuid)
            const localVarPath = `/surveys/{survey-uuid}/responses`
                .replace(`{${"survey-uuid"}}`, encodeURIComponent(String(surveyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all surveys for a group
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSurveysForGroup: async (hashedGroupId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hashedGroupId' is not null or undefined
            assertParamExists('listSurveysForGroup', 'hashedGroupId', hashedGroupId)
            const localVarPath = `/surveys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (hashedGroupId !== undefined) {
                localVarQueryParameter['hashedGroupId'] = hashedGroupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows re-ordering multiple modules at once. All modules must already exist. 
         * @summary Update the order of any number of modules
         * @param {Array<OrderingRequestItem>} orderingRequestItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderModules: async (orderingRequestItem: Array<OrderingRequestItem>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderingRequestItem' is not null or undefined
            assertParamExists('reorderModules', 'orderingRequestItem', orderingRequestItem)
            const localVarPath = `/modules/ordering`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderingRequestItem, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows re-ordering multiple parts at once. All parts must already exist. 
         * @summary Update the order of any number of parts
         * @param {Array<OrderingRequestItem>} orderingRequestItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderParts: async (orderingRequestItem: Array<OrderingRequestItem>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderingRequestItem' is not null or undefined
            assertParamExists('reorderParts', 'orderingRequestItem', orderingRequestItem)
            const localVarPath = `/parts/ordering`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderingRequestItem, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows re-ordering multiple steps at once. All steps must already exist. 
         * @summary Update the order of any number of steps
         * @param {Array<OrderingRequestItem>} orderingRequestItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderSteps: async (orderingRequestItem: Array<OrderingRequestItem>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderingRequestItem' is not null or undefined
            assertParamExists('reorderSteps', 'orderingRequestItem', orderingRequestItem)
            const localVarPath = `/steps/ordering`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderingRequestItem, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Causes the current user to be sent a sample certificate via email using the current program\'s settings. 
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSampleCertificate: async (programUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programUuid' is not null or undefined
            assertParamExists('sendSampleCertificate', 'programUuid', programUuid)
            const localVarPath = `/admin/programs/{program-uuid}/sample-certificate`
                .replace(`{${"program-uuid"}}`, encodeURIComponent(String(programUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The POST Module call allows for creation or modification of a Module object and it\'s properties, excluding Parts. In order to add a Part use POST on the parts endpoint. <br/> If the UUID is not provided it will create a Module on this Progam, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Module
         * @param {string} programUuid UUID of the Program
         * @param {UpsertModuleRequest} upsertModuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertModuleForProgram: async (programUuid: string, upsertModuleRequest: UpsertModuleRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programUuid' is not null or undefined
            assertParamExists('upsertModuleForProgram', 'programUuid', programUuid)
            // verify required parameter 'upsertModuleRequest' is not null or undefined
            assertParamExists('upsertModuleForProgram', 'upsertModuleRequest', upsertModuleRequest)
            const localVarPath = `/programs/{program-uuid}/modules`
                .replace(`{${"program-uuid"}}`, encodeURIComponent(String(programUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertModuleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The POST Part call allows for creation or modification of a Part object and it\'s properties, excluding Steps, under this Module. In order to add a Step under it use POST on the steps endpoint. <br/> I the UUID is not provided it will create a Part, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Part
         * @param {string} moduleUuid UUID of the Module
         * @param {UpsertPartRequest} upsertPartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertPartForModule: async (moduleUuid: string, upsertPartRequest: UpsertPartRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleUuid' is not null or undefined
            assertParamExists('upsertPartForModule', 'moduleUuid', moduleUuid)
            // verify required parameter 'upsertPartRequest' is not null or undefined
            assertParamExists('upsertPartForModule', 'upsertPartRequest', upsertPartRequest)
            const localVarPath = `/modules/{module-uuid}/parts`
                .replace(`{${"module-uuid"}}`, encodeURIComponent(String(moduleUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertPartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The POST Progam call allows for creation or modification of a Program object and it\'s properties, excluding Modules. In order to add a Module use POST on the modules endpoint. <br/> If the UUID is not provided it will create a Program, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Program
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {UpsertProgramRequest} upsertProgramRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertProgramForGroup: async (hashedGroupId: string, upsertProgramRequest: UpsertProgramRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hashedGroupId' is not null or undefined
            assertParamExists('upsertProgramForGroup', 'hashedGroupId', hashedGroupId)
            // verify required parameter 'upsertProgramRequest' is not null or undefined
            assertParamExists('upsertProgramForGroup', 'upsertProgramRequest', upsertProgramRequest)
            const localVarPath = `/admin/programs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (hashedGroupId !== undefined) {
                localVarQueryParameter['hashedGroupId'] = hashedGroupId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertProgramRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The POST Step call allows for creation or modification of a Step object and it\'s properties. <br/> I the UUID is not provided it will create a Step, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Step
         * @param {string} partUuid UUID of the Part
         * @param {UpsertStepRequest} upsertStepRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertStepForPart: async (partUuid: string, upsertStepRequest: UpsertStepRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partUuid' is not null or undefined
            assertParamExists('upsertStepForPart', 'partUuid', partUuid)
            // verify required parameter 'upsertStepRequest' is not null or undefined
            assertParamExists('upsertStepForPart', 'upsertStepRequest', upsertStepRequest)
            const localVarPath = `/parts/{part-uuid}/steps`
                .replace(`{${"part-uuid"}}`, encodeURIComponent(String(partUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertStepRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new survey for a group
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {UpsertSurveyRequest} upsertSurveyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertSurveyForGroup: async (hashedGroupId: string, upsertSurveyRequest: UpsertSurveyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hashedGroupId' is not null or undefined
            assertParamExists('upsertSurveyForGroup', 'hashedGroupId', hashedGroupId)
            // verify required parameter 'upsertSurveyRequest' is not null or undefined
            assertParamExists('upsertSurveyForGroup', 'upsertSurveyRequest', upsertSurveyRequest)
            const localVarPath = `/surveys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (hashedGroupId !== undefined) {
                localVarQueryParameter['hashedGroupId'] = hashedGroupId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertSurveyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdministrativeAPIsApi - functional programming interface
 * @export
 */
export const AdministrativeAPIsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdministrativeAPIsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns the details of a given Program, including the full hierarchy of dependent objects. This includes both published and unpublished Programs and Modules 
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFetchProgramById(programUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FullProgramResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFetchProgramById(programUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Return a summary list of Programs the authorized user has access to. This includes unpublished programs.
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminListProgramsForGroup(hashedGroupId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SimpleProgramResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminListProgramsForGroup(hashedGroupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deletes a given Module. This will also cascade deletion of any dependent objects.
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteModule(moduleUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteModule(moduleUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deletes a given Part. This will also cascade deletion of any dependent objects.
         * @param {string} partUuid UUID of the Part
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePart(partUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePart(partUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deletes a given Program. This will also cascade deletion of any dependent objects.
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProgramById(programUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProgramById(programUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deletes a given Step
         * @param {string} stepUuid UUID of the Step
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStep(stepUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStep(stepUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deletes a given survey. This is not allowed if there are surveyResponse objects linked to it.
         * @param {string} surveyUuid UUID of the survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSurveyById(surveyUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSurveyById(surveyUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Return a Module, including the full hierarchy of dependent objects.
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModule(moduleUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModule(moduleUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a summary list of Modules under a given Program.
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModulesByProgramId(programUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ModuleResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModulesByProgramId(programUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Return a Part, including the full hierarchy of steps it contains.
         * @param {string} partUuid UUID of the Part
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPart(partUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPart(partUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Return a summary list of Parts under a Module.
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartsForModule(moduleUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PartResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartsForModule(moduleUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all responses for a survey
         * @param {string} surveyUuid UUID of the survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSurveyResponsesForSurvey(surveyUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SurveyAnswersResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSurveyResponsesForSurvey(surveyUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all surveys for a group
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSurveysForGroup(hashedGroupId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SurveyResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSurveysForGroup(hashedGroupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allows re-ordering multiple modules at once. All modules must already exist. 
         * @summary Update the order of any number of modules
         * @param {Array<OrderingRequestItem>} orderingRequestItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorderModules(orderingRequestItem: Array<OrderingRequestItem>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorderModules(orderingRequestItem, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allows re-ordering multiple parts at once. All parts must already exist. 
         * @summary Update the order of any number of parts
         * @param {Array<OrderingRequestItem>} orderingRequestItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorderParts(orderingRequestItem: Array<OrderingRequestItem>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorderParts(orderingRequestItem, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allows re-ordering multiple steps at once. All steps must already exist. 
         * @summary Update the order of any number of steps
         * @param {Array<OrderingRequestItem>} orderingRequestItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorderSteps(orderingRequestItem: Array<OrderingRequestItem>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorderSteps(orderingRequestItem, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Causes the current user to be sent a sample certificate via email using the current program\'s settings. 
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendSampleCertificate(programUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendSampleCertificate(programUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The POST Module call allows for creation or modification of a Module object and it\'s properties, excluding Parts. In order to add a Part use POST on the parts endpoint. <br/> If the UUID is not provided it will create a Module on this Progam, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Module
         * @param {string} programUuid UUID of the Program
         * @param {UpsertModuleRequest} upsertModuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertModuleForProgram(programUuid: string, upsertModuleRequest: UpsertModuleRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertModuleForProgram(programUuid, upsertModuleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The POST Part call allows for creation or modification of a Part object and it\'s properties, excluding Steps, under this Module. In order to add a Step under it use POST on the steps endpoint. <br/> I the UUID is not provided it will create a Part, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Part
         * @param {string} moduleUuid UUID of the Module
         * @param {UpsertPartRequest} upsertPartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertPartForModule(moduleUuid: string, upsertPartRequest: UpsertPartRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertPartForModule(moduleUuid, upsertPartRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The POST Progam call allows for creation or modification of a Program object and it\'s properties, excluding Modules. In order to add a Module use POST on the modules endpoint. <br/> If the UUID is not provided it will create a Program, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Program
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {UpsertProgramRequest} upsertProgramRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertProgramForGroup(hashedGroupId: string, upsertProgramRequest: UpsertProgramRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimpleProgramResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertProgramForGroup(hashedGroupId, upsertProgramRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The POST Step call allows for creation or modification of a Step object and it\'s properties. <br/> I the UUID is not provided it will create a Step, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Step
         * @param {string} partUuid UUID of the Part
         * @param {UpsertStepRequest} upsertStepRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertStepForPart(partUuid: string, upsertStepRequest: UpsertStepRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertStepForPart(partUuid, upsertStepRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new survey for a group
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {UpsertSurveyRequest} upsertSurveyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertSurveyForGroup(hashedGroupId: string, upsertSurveyRequest: UpsertSurveyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertSurveyForGroup(hashedGroupId, upsertSurveyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdministrativeAPIsApi - factory interface
 * @export
 */
export const AdministrativeAPIsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdministrativeAPIsApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns the details of a given Program, including the full hierarchy of dependent objects. This includes both published and unpublished Programs and Modules 
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFetchProgramById(programUuid: string, options?: any): AxiosPromise<FullProgramResponse> {
            return localVarFp.adminFetchProgramById(programUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return a summary list of Programs the authorized user has access to. This includes unpublished programs.
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListProgramsForGroup(hashedGroupId: string, options?: any): AxiosPromise<Array<SimpleProgramResponse>> {
            return localVarFp.adminListProgramsForGroup(hashedGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a given Module. This will also cascade deletion of any dependent objects.
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteModule(moduleUuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteModule(moduleUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a given Part. This will also cascade deletion of any dependent objects.
         * @param {string} partUuid UUID of the Part
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePart(partUuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePart(partUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a given Program. This will also cascade deletion of any dependent objects.
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProgramById(programUuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteProgramById(programUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a given Step
         * @param {string} stepUuid UUID of the Step
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStep(stepUuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteStep(stepUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a given survey. This is not allowed if there are surveyResponse objects linked to it.
         * @param {string} surveyUuid UUID of the survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurveyById(surveyUuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteSurveyById(surveyUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return a Module, including the full hierarchy of dependent objects.
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModule(moduleUuid: string, options?: any): AxiosPromise<ModuleResponse> {
            return localVarFp.getModule(moduleUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a summary list of Modules under a given Program.
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModulesByProgramId(programUuid: string, options?: any): AxiosPromise<Array<ModuleResponse>> {
            return localVarFp.getModulesByProgramId(programUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return a Part, including the full hierarchy of steps it contains.
         * @param {string} partUuid UUID of the Part
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPart(partUuid: string, options?: any): AxiosPromise<PartResponse> {
            return localVarFp.getPart(partUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return a summary list of Parts under a Module.
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartsForModule(moduleUuid: string, options?: any): AxiosPromise<Array<PartResponse>> {
            return localVarFp.getPartsForModule(moduleUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all responses for a survey
         * @param {string} surveyUuid UUID of the survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSurveyResponsesForSurvey(surveyUuid: string, options?: any): AxiosPromise<Array<SurveyAnswersResponse>> {
            return localVarFp.listSurveyResponsesForSurvey(surveyUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all surveys for a group
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSurveysForGroup(hashedGroupId: string, options?: any): AxiosPromise<Array<SurveyResponse>> {
            return localVarFp.listSurveysForGroup(hashedGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows re-ordering multiple modules at once. All modules must already exist. 
         * @summary Update the order of any number of modules
         * @param {Array<OrderingRequestItem>} orderingRequestItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderModules(orderingRequestItem: Array<OrderingRequestItem>, options?: any): AxiosPromise<void> {
            return localVarFp.reorderModules(orderingRequestItem, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows re-ordering multiple parts at once. All parts must already exist. 
         * @summary Update the order of any number of parts
         * @param {Array<OrderingRequestItem>} orderingRequestItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderParts(orderingRequestItem: Array<OrderingRequestItem>, options?: any): AxiosPromise<void> {
            return localVarFp.reorderParts(orderingRequestItem, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows re-ordering multiple steps at once. All steps must already exist. 
         * @summary Update the order of any number of steps
         * @param {Array<OrderingRequestItem>} orderingRequestItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderSteps(orderingRequestItem: Array<OrderingRequestItem>, options?: any): AxiosPromise<void> {
            return localVarFp.reorderSteps(orderingRequestItem, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Causes the current user to be sent a sample certificate via email using the current program\'s settings. 
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSampleCertificate(programUuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.sendSampleCertificate(programUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * The POST Module call allows for creation or modification of a Module object and it\'s properties, excluding Parts. In order to add a Part use POST on the parts endpoint. <br/> If the UUID is not provided it will create a Module on this Progam, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Module
         * @param {string} programUuid UUID of the Program
         * @param {UpsertModuleRequest} upsertModuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertModuleForProgram(programUuid: string, upsertModuleRequest: UpsertModuleRequest, options?: any): AxiosPromise<ModuleResponse> {
            return localVarFp.upsertModuleForProgram(programUuid, upsertModuleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The POST Part call allows for creation or modification of a Part object and it\'s properties, excluding Steps, under this Module. In order to add a Step under it use POST on the steps endpoint. <br/> I the UUID is not provided it will create a Part, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Part
         * @param {string} moduleUuid UUID of the Module
         * @param {UpsertPartRequest} upsertPartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertPartForModule(moduleUuid: string, upsertPartRequest: UpsertPartRequest, options?: any): AxiosPromise<PartResponse> {
            return localVarFp.upsertPartForModule(moduleUuid, upsertPartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The POST Progam call allows for creation or modification of a Program object and it\'s properties, excluding Modules. In order to add a Module use POST on the modules endpoint. <br/> If the UUID is not provided it will create a Program, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Program
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {UpsertProgramRequest} upsertProgramRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertProgramForGroup(hashedGroupId: string, upsertProgramRequest: UpsertProgramRequest, options?: any): AxiosPromise<SimpleProgramResponse> {
            return localVarFp.upsertProgramForGroup(hashedGroupId, upsertProgramRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The POST Step call allows for creation or modification of a Step object and it\'s properties. <br/> I the UUID is not provided it will create a Step, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Step
         * @param {string} partUuid UUID of the Part
         * @param {UpsertStepRequest} upsertStepRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertStepForPart(partUuid: string, upsertStepRequest: UpsertStepRequest, options?: any): AxiosPromise<StepResponse> {
            return localVarFp.upsertStepForPart(partUuid, upsertStepRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new survey for a group
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {UpsertSurveyRequest} upsertSurveyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertSurveyForGroup(hashedGroupId: string, upsertSurveyRequest: UpsertSurveyRequest, options?: any): AxiosPromise<SurveyResponse> {
            return localVarFp.upsertSurveyForGroup(hashedGroupId, upsertSurveyRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdministrativeAPIsApi - object-oriented interface
 * @export
 * @class AdministrativeAPIsApi
 * @extends {BaseAPI}
 */
export class AdministrativeAPIsApi extends BaseAPI {
    /**
     * 
     * @summary Returns the details of a given Program, including the full hierarchy of dependent objects. This includes both published and unpublished Programs and Modules 
     * @param {string} programUuid UUID of the Program
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrativeAPIsApi
     */
    public adminFetchProgramById(programUuid: string, options?: AxiosRequestConfig) {
        return AdministrativeAPIsApiFp(this.configuration).adminFetchProgramById(programUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return a summary list of Programs the authorized user has access to. This includes unpublished programs.
     * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrativeAPIsApi
     */
    public adminListProgramsForGroup(hashedGroupId: string, options?: AxiosRequestConfig) {
        return AdministrativeAPIsApiFp(this.configuration).adminListProgramsForGroup(hashedGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a given Module. This will also cascade deletion of any dependent objects.
     * @param {string} moduleUuid UUID of the Module
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrativeAPIsApi
     */
    public deleteModule(moduleUuid: string, options?: AxiosRequestConfig) {
        return AdministrativeAPIsApiFp(this.configuration).deleteModule(moduleUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a given Part. This will also cascade deletion of any dependent objects.
     * @param {string} partUuid UUID of the Part
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrativeAPIsApi
     */
    public deletePart(partUuid: string, options?: AxiosRequestConfig) {
        return AdministrativeAPIsApiFp(this.configuration).deletePart(partUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a given Program. This will also cascade deletion of any dependent objects.
     * @param {string} programUuid UUID of the Program
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrativeAPIsApi
     */
    public deleteProgramById(programUuid: string, options?: AxiosRequestConfig) {
        return AdministrativeAPIsApiFp(this.configuration).deleteProgramById(programUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a given Step
     * @param {string} stepUuid UUID of the Step
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrativeAPIsApi
     */
    public deleteStep(stepUuid: string, options?: AxiosRequestConfig) {
        return AdministrativeAPIsApiFp(this.configuration).deleteStep(stepUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a given survey. This is not allowed if there are surveyResponse objects linked to it.
     * @param {string} surveyUuid UUID of the survey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrativeAPIsApi
     */
    public deleteSurveyById(surveyUuid: string, options?: AxiosRequestConfig) {
        return AdministrativeAPIsApiFp(this.configuration).deleteSurveyById(surveyUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return a Module, including the full hierarchy of dependent objects.
     * @param {string} moduleUuid UUID of the Module
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrativeAPIsApi
     */
    public getModule(moduleUuid: string, options?: AxiosRequestConfig) {
        return AdministrativeAPIsApiFp(this.configuration).getModule(moduleUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a summary list of Modules under a given Program.
     * @param {string} programUuid UUID of the Program
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrativeAPIsApi
     */
    public getModulesByProgramId(programUuid: string, options?: AxiosRequestConfig) {
        return AdministrativeAPIsApiFp(this.configuration).getModulesByProgramId(programUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return a Part, including the full hierarchy of steps it contains.
     * @param {string} partUuid UUID of the Part
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrativeAPIsApi
     */
    public getPart(partUuid: string, options?: AxiosRequestConfig) {
        return AdministrativeAPIsApiFp(this.configuration).getPart(partUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return a summary list of Parts under a Module.
     * @param {string} moduleUuid UUID of the Module
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrativeAPIsApi
     */
    public getPartsForModule(moduleUuid: string, options?: AxiosRequestConfig) {
        return AdministrativeAPIsApiFp(this.configuration).getPartsForModule(moduleUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all responses for a survey
     * @param {string} surveyUuid UUID of the survey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrativeAPIsApi
     */
    public listSurveyResponsesForSurvey(surveyUuid: string, options?: AxiosRequestConfig) {
        return AdministrativeAPIsApiFp(this.configuration).listSurveyResponsesForSurvey(surveyUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all surveys for a group
     * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrativeAPIsApi
     */
    public listSurveysForGroup(hashedGroupId: string, options?: AxiosRequestConfig) {
        return AdministrativeAPIsApiFp(this.configuration).listSurveysForGroup(hashedGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows re-ordering multiple modules at once. All modules must already exist. 
     * @summary Update the order of any number of modules
     * @param {Array<OrderingRequestItem>} orderingRequestItem 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrativeAPIsApi
     */
    public reorderModules(orderingRequestItem: Array<OrderingRequestItem>, options?: AxiosRequestConfig) {
        return AdministrativeAPIsApiFp(this.configuration).reorderModules(orderingRequestItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows re-ordering multiple parts at once. All parts must already exist. 
     * @summary Update the order of any number of parts
     * @param {Array<OrderingRequestItem>} orderingRequestItem 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrativeAPIsApi
     */
    public reorderParts(orderingRequestItem: Array<OrderingRequestItem>, options?: AxiosRequestConfig) {
        return AdministrativeAPIsApiFp(this.configuration).reorderParts(orderingRequestItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows re-ordering multiple steps at once. All steps must already exist. 
     * @summary Update the order of any number of steps
     * @param {Array<OrderingRequestItem>} orderingRequestItem 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrativeAPIsApi
     */
    public reorderSteps(orderingRequestItem: Array<OrderingRequestItem>, options?: AxiosRequestConfig) {
        return AdministrativeAPIsApiFp(this.configuration).reorderSteps(orderingRequestItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Causes the current user to be sent a sample certificate via email using the current program\'s settings. 
     * @param {string} programUuid UUID of the Program
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrativeAPIsApi
     */
    public sendSampleCertificate(programUuid: string, options?: AxiosRequestConfig) {
        return AdministrativeAPIsApiFp(this.configuration).sendSampleCertificate(programUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The POST Module call allows for creation or modification of a Module object and it\'s properties, excluding Parts. In order to add a Part use POST on the parts endpoint. <br/> If the UUID is not provided it will create a Module on this Progam, and if UUID _is_ present it will be updated. 
     * @summary Create or modify a Module
     * @param {string} programUuid UUID of the Program
     * @param {UpsertModuleRequest} upsertModuleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrativeAPIsApi
     */
    public upsertModuleForProgram(programUuid: string, upsertModuleRequest: UpsertModuleRequest, options?: AxiosRequestConfig) {
        return AdministrativeAPIsApiFp(this.configuration).upsertModuleForProgram(programUuid, upsertModuleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The POST Part call allows for creation or modification of a Part object and it\'s properties, excluding Steps, under this Module. In order to add a Step under it use POST on the steps endpoint. <br/> I the UUID is not provided it will create a Part, and if UUID _is_ present it will be updated. 
     * @summary Create or modify a Part
     * @param {string} moduleUuid UUID of the Module
     * @param {UpsertPartRequest} upsertPartRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrativeAPIsApi
     */
    public upsertPartForModule(moduleUuid: string, upsertPartRequest: UpsertPartRequest, options?: AxiosRequestConfig) {
        return AdministrativeAPIsApiFp(this.configuration).upsertPartForModule(moduleUuid, upsertPartRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The POST Progam call allows for creation or modification of a Program object and it\'s properties, excluding Modules. In order to add a Module use POST on the modules endpoint. <br/> If the UUID is not provided it will create a Program, and if UUID _is_ present it will be updated. 
     * @summary Create or modify a Program
     * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
     * @param {UpsertProgramRequest} upsertProgramRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrativeAPIsApi
     */
    public upsertProgramForGroup(hashedGroupId: string, upsertProgramRequest: UpsertProgramRequest, options?: AxiosRequestConfig) {
        return AdministrativeAPIsApiFp(this.configuration).upsertProgramForGroup(hashedGroupId, upsertProgramRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The POST Step call allows for creation or modification of a Step object and it\'s properties. <br/> I the UUID is not provided it will create a Step, and if UUID _is_ present it will be updated. 
     * @summary Create or modify a Step
     * @param {string} partUuid UUID of the Part
     * @param {UpsertStepRequest} upsertStepRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrativeAPIsApi
     */
    public upsertStepForPart(partUuid: string, upsertStepRequest: UpsertStepRequest, options?: AxiosRequestConfig) {
        return AdministrativeAPIsApiFp(this.configuration).upsertStepForPart(partUuid, upsertStepRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new survey for a group
     * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
     * @param {UpsertSurveyRequest} upsertSurveyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrativeAPIsApi
     */
    public upsertSurveyForGroup(hashedGroupId: string, upsertSurveyRequest: UpsertSurveyRequest, options?: AxiosRequestConfig) {
        return AdministrativeAPIsApiFp(this.configuration).upsertSurveyForGroup(hashedGroupId, upsertSurveyRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ModulesApi - axios parameter creator
 * @export
 */
export const ModulesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Deletes a given Module. This will also cascade deletion of any dependent objects.
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteModule: async (moduleUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleUuid' is not null or undefined
            assertParamExists('deleteModule', 'moduleUuid', moduleUuid)
            const localVarPath = `/modules/{module-uuid}`
                .replace(`{${"module-uuid"}}`, encodeURIComponent(String(moduleUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sends an email with a certificate PDF of a given Module for the current user 
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailModuleCertificate: async (moduleUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleUuid' is not null or undefined
            assertParamExists('emailModuleCertificate', 'moduleUuid', moduleUuid)
            const localVarPath = `/modules/{module-uuid}/email-certificate`
                .replace(`{${"module-uuid"}}`, encodeURIComponent(String(moduleUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return a Module, including the full hierarchy of dependent objects.
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModule: async (moduleUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleUuid' is not null or undefined
            assertParamExists('getModule', 'moduleUuid', moduleUuid)
            const localVarPath = `/modules/{module-uuid}`
                .replace(`{${"module-uuid"}}`, encodeURIComponent(String(moduleUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a summary list of Modules under a given Program.
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModulesByProgramId: async (programUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programUuid' is not null or undefined
            assertParamExists('getModulesByProgramId', 'programUuid', programUuid)
            const localVarPath = `/programs/{program-uuid}/modules`
                .replace(`{${"program-uuid"}}`, encodeURIComponent(String(programUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return a summary list of Parts under a Module.
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartsForModule: async (moduleUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleUuid' is not null or undefined
            assertParamExists('getPartsForModule', 'moduleUuid', moduleUuid)
            const localVarPath = `/modules/{module-uuid}/parts`
                .replace(`{${"module-uuid"}}`, encodeURIComponent(String(moduleUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows re-ordering multiple modules at once. All modules must already exist. 
         * @summary Update the order of any number of modules
         * @param {Array<OrderingRequestItem>} orderingRequestItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderModules: async (orderingRequestItem: Array<OrderingRequestItem>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderingRequestItem' is not null or undefined
            assertParamExists('reorderModules', 'orderingRequestItem', orderingRequestItem)
            const localVarPath = `/modules/ordering`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderingRequestItem, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The POST Module call allows for creation or modification of a Module object and it\'s properties, excluding Parts. In order to add a Part use POST on the parts endpoint. <br/> If the UUID is not provided it will create a Module on this Progam, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Module
         * @param {string} programUuid UUID of the Program
         * @param {UpsertModuleRequest} upsertModuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertModuleForProgram: async (programUuid: string, upsertModuleRequest: UpsertModuleRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programUuid' is not null or undefined
            assertParamExists('upsertModuleForProgram', 'programUuid', programUuid)
            // verify required parameter 'upsertModuleRequest' is not null or undefined
            assertParamExists('upsertModuleForProgram', 'upsertModuleRequest', upsertModuleRequest)
            const localVarPath = `/programs/{program-uuid}/modules`
                .replace(`{${"program-uuid"}}`, encodeURIComponent(String(programUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertModuleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The POST Part call allows for creation or modification of a Part object and it\'s properties, excluding Steps, under this Module. In order to add a Step under it use POST on the steps endpoint. <br/> I the UUID is not provided it will create a Part, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Part
         * @param {string} moduleUuid UUID of the Module
         * @param {UpsertPartRequest} upsertPartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertPartForModule: async (moduleUuid: string, upsertPartRequest: UpsertPartRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleUuid' is not null or undefined
            assertParamExists('upsertPartForModule', 'moduleUuid', moduleUuid)
            // verify required parameter 'upsertPartRequest' is not null or undefined
            assertParamExists('upsertPartForModule', 'upsertPartRequest', upsertPartRequest)
            const localVarPath = `/modules/{module-uuid}/parts`
                .replace(`{${"module-uuid"}}`, encodeURIComponent(String(moduleUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertPartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ModulesApi - functional programming interface
 * @export
 */
export const ModulesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ModulesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Deletes a given Module. This will also cascade deletion of any dependent objects.
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteModule(moduleUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteModule(moduleUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sends an email with a certificate PDF of a given Module for the current user 
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailModuleCertificate(moduleUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailModuleCertificate(moduleUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Return a Module, including the full hierarchy of dependent objects.
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModule(moduleUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModule(moduleUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a summary list of Modules under a given Program.
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModulesByProgramId(programUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ModuleResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModulesByProgramId(programUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Return a summary list of Parts under a Module.
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartsForModule(moduleUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PartResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartsForModule(moduleUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allows re-ordering multiple modules at once. All modules must already exist. 
         * @summary Update the order of any number of modules
         * @param {Array<OrderingRequestItem>} orderingRequestItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorderModules(orderingRequestItem: Array<OrderingRequestItem>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorderModules(orderingRequestItem, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The POST Module call allows for creation or modification of a Module object and it\'s properties, excluding Parts. In order to add a Part use POST on the parts endpoint. <br/> If the UUID is not provided it will create a Module on this Progam, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Module
         * @param {string} programUuid UUID of the Program
         * @param {UpsertModuleRequest} upsertModuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertModuleForProgram(programUuid: string, upsertModuleRequest: UpsertModuleRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertModuleForProgram(programUuid, upsertModuleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The POST Part call allows for creation or modification of a Part object and it\'s properties, excluding Steps, under this Module. In order to add a Step under it use POST on the steps endpoint. <br/> I the UUID is not provided it will create a Part, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Part
         * @param {string} moduleUuid UUID of the Module
         * @param {UpsertPartRequest} upsertPartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertPartForModule(moduleUuid: string, upsertPartRequest: UpsertPartRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertPartForModule(moduleUuid, upsertPartRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ModulesApi - factory interface
 * @export
 */
export const ModulesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ModulesApiFp(configuration)
    return {
        /**
         * 
         * @summary Deletes a given Module. This will also cascade deletion of any dependent objects.
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteModule(moduleUuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteModule(moduleUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sends an email with a certificate PDF of a given Module for the current user 
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailModuleCertificate(moduleUuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.emailModuleCertificate(moduleUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return a Module, including the full hierarchy of dependent objects.
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModule(moduleUuid: string, options?: any): AxiosPromise<ModuleResponse> {
            return localVarFp.getModule(moduleUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a summary list of Modules under a given Program.
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModulesByProgramId(programUuid: string, options?: any): AxiosPromise<Array<ModuleResponse>> {
            return localVarFp.getModulesByProgramId(programUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return a summary list of Parts under a Module.
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartsForModule(moduleUuid: string, options?: any): AxiosPromise<Array<PartResponse>> {
            return localVarFp.getPartsForModule(moduleUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows re-ordering multiple modules at once. All modules must already exist. 
         * @summary Update the order of any number of modules
         * @param {Array<OrderingRequestItem>} orderingRequestItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderModules(orderingRequestItem: Array<OrderingRequestItem>, options?: any): AxiosPromise<void> {
            return localVarFp.reorderModules(orderingRequestItem, options).then((request) => request(axios, basePath));
        },
        /**
         * The POST Module call allows for creation or modification of a Module object and it\'s properties, excluding Parts. In order to add a Part use POST on the parts endpoint. <br/> If the UUID is not provided it will create a Module on this Progam, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Module
         * @param {string} programUuid UUID of the Program
         * @param {UpsertModuleRequest} upsertModuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertModuleForProgram(programUuid: string, upsertModuleRequest: UpsertModuleRequest, options?: any): AxiosPromise<ModuleResponse> {
            return localVarFp.upsertModuleForProgram(programUuid, upsertModuleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The POST Part call allows for creation or modification of a Part object and it\'s properties, excluding Steps, under this Module. In order to add a Step under it use POST on the steps endpoint. <br/> I the UUID is not provided it will create a Part, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Part
         * @param {string} moduleUuid UUID of the Module
         * @param {UpsertPartRequest} upsertPartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertPartForModule(moduleUuid: string, upsertPartRequest: UpsertPartRequest, options?: any): AxiosPromise<PartResponse> {
            return localVarFp.upsertPartForModule(moduleUuid, upsertPartRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ModulesApi - object-oriented interface
 * @export
 * @class ModulesApi
 * @extends {BaseAPI}
 */
export class ModulesApi extends BaseAPI {
    /**
     * 
     * @summary Deletes a given Module. This will also cascade deletion of any dependent objects.
     * @param {string} moduleUuid UUID of the Module
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModulesApi
     */
    public deleteModule(moduleUuid: string, options?: AxiosRequestConfig) {
        return ModulesApiFp(this.configuration).deleteModule(moduleUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sends an email with a certificate PDF of a given Module for the current user 
     * @param {string} moduleUuid UUID of the Module
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModulesApi
     */
    public emailModuleCertificate(moduleUuid: string, options?: AxiosRequestConfig) {
        return ModulesApiFp(this.configuration).emailModuleCertificate(moduleUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return a Module, including the full hierarchy of dependent objects.
     * @param {string} moduleUuid UUID of the Module
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModulesApi
     */
    public getModule(moduleUuid: string, options?: AxiosRequestConfig) {
        return ModulesApiFp(this.configuration).getModule(moduleUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a summary list of Modules under a given Program.
     * @param {string} programUuid UUID of the Program
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModulesApi
     */
    public getModulesByProgramId(programUuid: string, options?: AxiosRequestConfig) {
        return ModulesApiFp(this.configuration).getModulesByProgramId(programUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return a summary list of Parts under a Module.
     * @param {string} moduleUuid UUID of the Module
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModulesApi
     */
    public getPartsForModule(moduleUuid: string, options?: AxiosRequestConfig) {
        return ModulesApiFp(this.configuration).getPartsForModule(moduleUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows re-ordering multiple modules at once. All modules must already exist. 
     * @summary Update the order of any number of modules
     * @param {Array<OrderingRequestItem>} orderingRequestItem 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModulesApi
     */
    public reorderModules(orderingRequestItem: Array<OrderingRequestItem>, options?: AxiosRequestConfig) {
        return ModulesApiFp(this.configuration).reorderModules(orderingRequestItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The POST Module call allows for creation or modification of a Module object and it\'s properties, excluding Parts. In order to add a Part use POST on the parts endpoint. <br/> If the UUID is not provided it will create a Module on this Progam, and if UUID _is_ present it will be updated. 
     * @summary Create or modify a Module
     * @param {string} programUuid UUID of the Program
     * @param {UpsertModuleRequest} upsertModuleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModulesApi
     */
    public upsertModuleForProgram(programUuid: string, upsertModuleRequest: UpsertModuleRequest, options?: AxiosRequestConfig) {
        return ModulesApiFp(this.configuration).upsertModuleForProgram(programUuid, upsertModuleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The POST Part call allows for creation or modification of a Part object and it\'s properties, excluding Steps, under this Module. In order to add a Step under it use POST on the steps endpoint. <br/> I the UUID is not provided it will create a Part, and if UUID _is_ present it will be updated. 
     * @summary Create or modify a Part
     * @param {string} moduleUuid UUID of the Module
     * @param {UpsertPartRequest} upsertPartRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModulesApi
     */
    public upsertPartForModule(moduleUuid: string, upsertPartRequest: UpsertPartRequest, options?: AxiosRequestConfig) {
        return ModulesApiFp(this.configuration).upsertPartForModule(moduleUuid, upsertPartRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PartsApi - axios parameter creator
 * @export
 */
export const PartsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Deletes a given Part. This will also cascade deletion of any dependent objects.
         * @param {string} partUuid UUID of the Part
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePart: async (partUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partUuid' is not null or undefined
            assertParamExists('deletePart', 'partUuid', partUuid)
            const localVarPath = `/parts/{part-uuid}`
                .replace(`{${"part-uuid"}}`, encodeURIComponent(String(partUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return a Part, including the full hierarchy of steps it contains.
         * @param {string} partUuid UUID of the Part
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPart: async (partUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partUuid' is not null or undefined
            assertParamExists('getPart', 'partUuid', partUuid)
            const localVarPath = `/parts/{part-uuid}`
                .replace(`{${"part-uuid"}}`, encodeURIComponent(String(partUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return a summary list of Parts under a Module.
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartsForModule: async (moduleUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleUuid' is not null or undefined
            assertParamExists('getPartsForModule', 'moduleUuid', moduleUuid)
            const localVarPath = `/modules/{module-uuid}/parts`
                .replace(`{${"module-uuid"}}`, encodeURIComponent(String(moduleUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows re-ordering multiple parts at once. All parts must already exist. 
         * @summary Update the order of any number of parts
         * @param {Array<OrderingRequestItem>} orderingRequestItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderParts: async (orderingRequestItem: Array<OrderingRequestItem>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderingRequestItem' is not null or undefined
            assertParamExists('reorderParts', 'orderingRequestItem', orderingRequestItem)
            const localVarPath = `/parts/ordering`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderingRequestItem, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The POST Part call allows for creation or modification of a Part object and it\'s properties, excluding Steps, under this Module. In order to add a Step under it use POST on the steps endpoint. <br/> I the UUID is not provided it will create a Part, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Part
         * @param {string} moduleUuid UUID of the Module
         * @param {UpsertPartRequest} upsertPartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertPartForModule: async (moduleUuid: string, upsertPartRequest: UpsertPartRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleUuid' is not null or undefined
            assertParamExists('upsertPartForModule', 'moduleUuid', moduleUuid)
            // verify required parameter 'upsertPartRequest' is not null or undefined
            assertParamExists('upsertPartForModule', 'upsertPartRequest', upsertPartRequest)
            const localVarPath = `/modules/{module-uuid}/parts`
                .replace(`{${"module-uuid"}}`, encodeURIComponent(String(moduleUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertPartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The POST Step call allows for creation or modification of a Step object and it\'s properties. <br/> I the UUID is not provided it will create a Step, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Step
         * @param {string} partUuid UUID of the Part
         * @param {UpsertStepRequest} upsertStepRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertStepForPart: async (partUuid: string, upsertStepRequest: UpsertStepRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partUuid' is not null or undefined
            assertParamExists('upsertStepForPart', 'partUuid', partUuid)
            // verify required parameter 'upsertStepRequest' is not null or undefined
            assertParamExists('upsertStepForPart', 'upsertStepRequest', upsertStepRequest)
            const localVarPath = `/parts/{part-uuid}/steps`
                .replace(`{${"part-uuid"}}`, encodeURIComponent(String(partUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertStepRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartsApi - functional programming interface
 * @export
 */
export const PartsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PartsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Deletes a given Part. This will also cascade deletion of any dependent objects.
         * @param {string} partUuid UUID of the Part
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePart(partUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePart(partUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Return a Part, including the full hierarchy of steps it contains.
         * @param {string} partUuid UUID of the Part
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPart(partUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPart(partUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Return a summary list of Parts under a Module.
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartsForModule(moduleUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PartResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartsForModule(moduleUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allows re-ordering multiple parts at once. All parts must already exist. 
         * @summary Update the order of any number of parts
         * @param {Array<OrderingRequestItem>} orderingRequestItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorderParts(orderingRequestItem: Array<OrderingRequestItem>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorderParts(orderingRequestItem, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The POST Part call allows for creation or modification of a Part object and it\'s properties, excluding Steps, under this Module. In order to add a Step under it use POST on the steps endpoint. <br/> I the UUID is not provided it will create a Part, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Part
         * @param {string} moduleUuid UUID of the Module
         * @param {UpsertPartRequest} upsertPartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertPartForModule(moduleUuid: string, upsertPartRequest: UpsertPartRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertPartForModule(moduleUuid, upsertPartRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The POST Step call allows for creation or modification of a Step object and it\'s properties. <br/> I the UUID is not provided it will create a Step, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Step
         * @param {string} partUuid UUID of the Part
         * @param {UpsertStepRequest} upsertStepRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertStepForPart(partUuid: string, upsertStepRequest: UpsertStepRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertStepForPart(partUuid, upsertStepRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PartsApi - factory interface
 * @export
 */
export const PartsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PartsApiFp(configuration)
    return {
        /**
         * 
         * @summary Deletes a given Part. This will also cascade deletion of any dependent objects.
         * @param {string} partUuid UUID of the Part
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePart(partUuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePart(partUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return a Part, including the full hierarchy of steps it contains.
         * @param {string} partUuid UUID of the Part
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPart(partUuid: string, options?: any): AxiosPromise<PartResponse> {
            return localVarFp.getPart(partUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return a summary list of Parts under a Module.
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartsForModule(moduleUuid: string, options?: any): AxiosPromise<Array<PartResponse>> {
            return localVarFp.getPartsForModule(moduleUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows re-ordering multiple parts at once. All parts must already exist. 
         * @summary Update the order of any number of parts
         * @param {Array<OrderingRequestItem>} orderingRequestItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderParts(orderingRequestItem: Array<OrderingRequestItem>, options?: any): AxiosPromise<void> {
            return localVarFp.reorderParts(orderingRequestItem, options).then((request) => request(axios, basePath));
        },
        /**
         * The POST Part call allows for creation or modification of a Part object and it\'s properties, excluding Steps, under this Module. In order to add a Step under it use POST on the steps endpoint. <br/> I the UUID is not provided it will create a Part, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Part
         * @param {string} moduleUuid UUID of the Module
         * @param {UpsertPartRequest} upsertPartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertPartForModule(moduleUuid: string, upsertPartRequest: UpsertPartRequest, options?: any): AxiosPromise<PartResponse> {
            return localVarFp.upsertPartForModule(moduleUuid, upsertPartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The POST Step call allows for creation or modification of a Step object and it\'s properties. <br/> I the UUID is not provided it will create a Step, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Step
         * @param {string} partUuid UUID of the Part
         * @param {UpsertStepRequest} upsertStepRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertStepForPart(partUuid: string, upsertStepRequest: UpsertStepRequest, options?: any): AxiosPromise<StepResponse> {
            return localVarFp.upsertStepForPart(partUuid, upsertStepRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PartsApi - object-oriented interface
 * @export
 * @class PartsApi
 * @extends {BaseAPI}
 */
export class PartsApi extends BaseAPI {
    /**
     * 
     * @summary Deletes a given Part. This will also cascade deletion of any dependent objects.
     * @param {string} partUuid UUID of the Part
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    public deletePart(partUuid: string, options?: AxiosRequestConfig) {
        return PartsApiFp(this.configuration).deletePart(partUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return a Part, including the full hierarchy of steps it contains.
     * @param {string} partUuid UUID of the Part
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    public getPart(partUuid: string, options?: AxiosRequestConfig) {
        return PartsApiFp(this.configuration).getPart(partUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return a summary list of Parts under a Module.
     * @param {string} moduleUuid UUID of the Module
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    public getPartsForModule(moduleUuid: string, options?: AxiosRequestConfig) {
        return PartsApiFp(this.configuration).getPartsForModule(moduleUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows re-ordering multiple parts at once. All parts must already exist. 
     * @summary Update the order of any number of parts
     * @param {Array<OrderingRequestItem>} orderingRequestItem 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    public reorderParts(orderingRequestItem: Array<OrderingRequestItem>, options?: AxiosRequestConfig) {
        return PartsApiFp(this.configuration).reorderParts(orderingRequestItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The POST Part call allows for creation or modification of a Part object and it\'s properties, excluding Steps, under this Module. In order to add a Step under it use POST on the steps endpoint. <br/> I the UUID is not provided it will create a Part, and if UUID _is_ present it will be updated. 
     * @summary Create or modify a Part
     * @param {string} moduleUuid UUID of the Module
     * @param {UpsertPartRequest} upsertPartRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    public upsertPartForModule(moduleUuid: string, upsertPartRequest: UpsertPartRequest, options?: AxiosRequestConfig) {
        return PartsApiFp(this.configuration).upsertPartForModule(moduleUuid, upsertPartRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The POST Step call allows for creation or modification of a Step object and it\'s properties. <br/> I the UUID is not provided it will create a Step, and if UUID _is_ present it will be updated. 
     * @summary Create or modify a Step
     * @param {string} partUuid UUID of the Part
     * @param {UpsertStepRequest} upsertStepRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    public upsertStepForPart(partUuid: string, upsertStepRequest: UpsertStepRequest, options?: AxiosRequestConfig) {
        return PartsApiFp(this.configuration).upsertStepForPart(partUuid, upsertStepRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProgramsApi - axios parameter creator
 * @export
 */
export const ProgramsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns the details of a given Program, including the full hierarchy of dependent objects. This includes both published and unpublished Programs and Modules 
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFetchProgramById: async (programUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programUuid' is not null or undefined
            assertParamExists('adminFetchProgramById', 'programUuid', programUuid)
            const localVarPath = `/admin/programs/{program-uuid}`
                .replace(`{${"program-uuid"}}`, encodeURIComponent(String(programUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return a summary list of Programs the authorized user has access to. This includes unpublished programs.
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListProgramsForGroup: async (hashedGroupId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hashedGroupId' is not null or undefined
            assertParamExists('adminListProgramsForGroup', 'hashedGroupId', hashedGroupId)
            const localVarPath = `/admin/programs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (hashedGroupId !== undefined) {
                localVarQueryParameter['hashedGroupId'] = hashedGroupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a given Program. This will also cascade deletion of any dependent objects.
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProgramById: async (programUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programUuid' is not null or undefined
            assertParamExists('deleteProgramById', 'programUuid', programUuid)
            const localVarPath = `/admin/programs/{program-uuid}`
                .replace(`{${"program-uuid"}}`, encodeURIComponent(String(programUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sends an email with a certificate PDF of a given Program for the current user 
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailProgramCertificate: async (programUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programUuid' is not null or undefined
            assertParamExists('emailProgramCertificate', 'programUuid', programUuid)
            const localVarPath = `/programs/{program-uuid}/email-certificate`
                .replace(`{${"program-uuid"}}`, encodeURIComponent(String(programUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the details of a given Program, including the full hierarchy of dependent objects. This includes only published Programs and Modules 
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchProgramById: async (programUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programUuid' is not null or undefined
            assertParamExists('fetchProgramById', 'programUuid', programUuid)
            const localVarPath = `/programs/{program-uuid}`
                .replace(`{${"program-uuid"}}`, encodeURIComponent(String(programUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a summary list of Modules under a given Program.
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModulesByProgramId: async (programUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programUuid' is not null or undefined
            assertParamExists('getModulesByProgramId', 'programUuid', programUuid)
            const localVarPath = `/programs/{program-uuid}/modules`
                .replace(`{${"program-uuid"}}`, encodeURIComponent(String(programUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return a summary list of Programs the authorized user has access to. This does not include unpublished programs.
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProgramsForGroup: async (hashedGroupId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hashedGroupId' is not null or undefined
            assertParamExists('listProgramsForGroup', 'hashedGroupId', hashedGroupId)
            const localVarPath = `/programs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (hashedGroupId !== undefined) {
                localVarQueryParameter['hashedGroupId'] = hashedGroupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a summary list of Programs the authorized user has started
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStartedProgramsForUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/programs/started`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Causes the current user to be sent a sample certificate via email using the current program\'s settings. 
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSampleCertificate: async (programUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programUuid' is not null or undefined
            assertParamExists('sendSampleCertificate', 'programUuid', programUuid)
            const localVarPath = `/admin/programs/{program-uuid}/sample-certificate`
                .replace(`{${"program-uuid"}}`, encodeURIComponent(String(programUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The POST Module call allows for creation or modification of a Module object and it\'s properties, excluding Parts. In order to add a Part use POST on the parts endpoint. <br/> If the UUID is not provided it will create a Module on this Progam, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Module
         * @param {string} programUuid UUID of the Program
         * @param {UpsertModuleRequest} upsertModuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertModuleForProgram: async (programUuid: string, upsertModuleRequest: UpsertModuleRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programUuid' is not null or undefined
            assertParamExists('upsertModuleForProgram', 'programUuid', programUuid)
            // verify required parameter 'upsertModuleRequest' is not null or undefined
            assertParamExists('upsertModuleForProgram', 'upsertModuleRequest', upsertModuleRequest)
            const localVarPath = `/programs/{program-uuid}/modules`
                .replace(`{${"program-uuid"}}`, encodeURIComponent(String(programUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertModuleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The POST Progam call allows for creation or modification of a Program object and it\'s properties, excluding Modules. In order to add a Module use POST on the modules endpoint. <br/> If the UUID is not provided it will create a Program, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Program
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {UpsertProgramRequest} upsertProgramRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertProgramForGroup: async (hashedGroupId: string, upsertProgramRequest: UpsertProgramRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hashedGroupId' is not null or undefined
            assertParamExists('upsertProgramForGroup', 'hashedGroupId', hashedGroupId)
            // verify required parameter 'upsertProgramRequest' is not null or undefined
            assertParamExists('upsertProgramForGroup', 'upsertProgramRequest', upsertProgramRequest)
            const localVarPath = `/admin/programs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (hashedGroupId !== undefined) {
                localVarQueryParameter['hashedGroupId'] = hashedGroupId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertProgramRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProgramsApi - functional programming interface
 * @export
 */
export const ProgramsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProgramsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns the details of a given Program, including the full hierarchy of dependent objects. This includes both published and unpublished Programs and Modules 
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFetchProgramById(programUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FullProgramResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFetchProgramById(programUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Return a summary list of Programs the authorized user has access to. This includes unpublished programs.
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminListProgramsForGroup(hashedGroupId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SimpleProgramResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminListProgramsForGroup(hashedGroupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deletes a given Program. This will also cascade deletion of any dependent objects.
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProgramById(programUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProgramById(programUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sends an email with a certificate PDF of a given Program for the current user 
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailProgramCertificate(programUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailProgramCertificate(programUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the details of a given Program, including the full hierarchy of dependent objects. This includes only published Programs and Modules 
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchProgramById(programUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FullProgramResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchProgramById(programUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a summary list of Modules under a given Program.
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModulesByProgramId(programUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ModuleResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModulesByProgramId(programUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Return a summary list of Programs the authorized user has access to. This does not include unpublished programs.
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listProgramsForGroup(hashedGroupId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SimpleProgramResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listProgramsForGroup(hashedGroupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a summary list of Programs the authorized user has started
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStartedProgramsForUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserStartedProgramResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listStartedProgramsForUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Causes the current user to be sent a sample certificate via email using the current program\'s settings. 
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendSampleCertificate(programUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendSampleCertificate(programUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The POST Module call allows for creation or modification of a Module object and it\'s properties, excluding Parts. In order to add a Part use POST on the parts endpoint. <br/> If the UUID is not provided it will create a Module on this Progam, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Module
         * @param {string} programUuid UUID of the Program
         * @param {UpsertModuleRequest} upsertModuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertModuleForProgram(programUuid: string, upsertModuleRequest: UpsertModuleRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertModuleForProgram(programUuid, upsertModuleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The POST Progam call allows for creation or modification of a Program object and it\'s properties, excluding Modules. In order to add a Module use POST on the modules endpoint. <br/> If the UUID is not provided it will create a Program, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Program
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {UpsertProgramRequest} upsertProgramRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertProgramForGroup(hashedGroupId: string, upsertProgramRequest: UpsertProgramRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimpleProgramResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertProgramForGroup(hashedGroupId, upsertProgramRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProgramsApi - factory interface
 * @export
 */
export const ProgramsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProgramsApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns the details of a given Program, including the full hierarchy of dependent objects. This includes both published and unpublished Programs and Modules 
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFetchProgramById(programUuid: string, options?: any): AxiosPromise<FullProgramResponse> {
            return localVarFp.adminFetchProgramById(programUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return a summary list of Programs the authorized user has access to. This includes unpublished programs.
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListProgramsForGroup(hashedGroupId: string, options?: any): AxiosPromise<Array<SimpleProgramResponse>> {
            return localVarFp.adminListProgramsForGroup(hashedGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a given Program. This will also cascade deletion of any dependent objects.
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProgramById(programUuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteProgramById(programUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sends an email with a certificate PDF of a given Program for the current user 
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailProgramCertificate(programUuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.emailProgramCertificate(programUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the details of a given Program, including the full hierarchy of dependent objects. This includes only published Programs and Modules 
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchProgramById(programUuid: string, options?: any): AxiosPromise<FullProgramResponse> {
            return localVarFp.fetchProgramById(programUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a summary list of Modules under a given Program.
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModulesByProgramId(programUuid: string, options?: any): AxiosPromise<Array<ModuleResponse>> {
            return localVarFp.getModulesByProgramId(programUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return a summary list of Programs the authorized user has access to. This does not include unpublished programs.
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProgramsForGroup(hashedGroupId: string, options?: any): AxiosPromise<Array<SimpleProgramResponse>> {
            return localVarFp.listProgramsForGroup(hashedGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a summary list of Programs the authorized user has started
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStartedProgramsForUser(options?: any): AxiosPromise<Array<UserStartedProgramResponse>> {
            return localVarFp.listStartedProgramsForUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Causes the current user to be sent a sample certificate via email using the current program\'s settings. 
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSampleCertificate(programUuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.sendSampleCertificate(programUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * The POST Module call allows for creation or modification of a Module object and it\'s properties, excluding Parts. In order to add a Part use POST on the parts endpoint. <br/> If the UUID is not provided it will create a Module on this Progam, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Module
         * @param {string} programUuid UUID of the Program
         * @param {UpsertModuleRequest} upsertModuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertModuleForProgram(programUuid: string, upsertModuleRequest: UpsertModuleRequest, options?: any): AxiosPromise<ModuleResponse> {
            return localVarFp.upsertModuleForProgram(programUuid, upsertModuleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The POST Progam call allows for creation or modification of a Program object and it\'s properties, excluding Modules. In order to add a Module use POST on the modules endpoint. <br/> If the UUID is not provided it will create a Program, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Program
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {UpsertProgramRequest} upsertProgramRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertProgramForGroup(hashedGroupId: string, upsertProgramRequest: UpsertProgramRequest, options?: any): AxiosPromise<SimpleProgramResponse> {
            return localVarFp.upsertProgramForGroup(hashedGroupId, upsertProgramRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProgramsApi - object-oriented interface
 * @export
 * @class ProgramsApi
 * @extends {BaseAPI}
 */
export class ProgramsApi extends BaseAPI {
    /**
     * 
     * @summary Returns the details of a given Program, including the full hierarchy of dependent objects. This includes both published and unpublished Programs and Modules 
     * @param {string} programUuid UUID of the Program
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramsApi
     */
    public adminFetchProgramById(programUuid: string, options?: AxiosRequestConfig) {
        return ProgramsApiFp(this.configuration).adminFetchProgramById(programUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return a summary list of Programs the authorized user has access to. This includes unpublished programs.
     * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramsApi
     */
    public adminListProgramsForGroup(hashedGroupId: string, options?: AxiosRequestConfig) {
        return ProgramsApiFp(this.configuration).adminListProgramsForGroup(hashedGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a given Program. This will also cascade deletion of any dependent objects.
     * @param {string} programUuid UUID of the Program
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramsApi
     */
    public deleteProgramById(programUuid: string, options?: AxiosRequestConfig) {
        return ProgramsApiFp(this.configuration).deleteProgramById(programUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sends an email with a certificate PDF of a given Program for the current user 
     * @param {string} programUuid UUID of the Program
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramsApi
     */
    public emailProgramCertificate(programUuid: string, options?: AxiosRequestConfig) {
        return ProgramsApiFp(this.configuration).emailProgramCertificate(programUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the details of a given Program, including the full hierarchy of dependent objects. This includes only published Programs and Modules 
     * @param {string} programUuid UUID of the Program
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramsApi
     */
    public fetchProgramById(programUuid: string, options?: AxiosRequestConfig) {
        return ProgramsApiFp(this.configuration).fetchProgramById(programUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a summary list of Modules under a given Program.
     * @param {string} programUuid UUID of the Program
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramsApi
     */
    public getModulesByProgramId(programUuid: string, options?: AxiosRequestConfig) {
        return ProgramsApiFp(this.configuration).getModulesByProgramId(programUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return a summary list of Programs the authorized user has access to. This does not include unpublished programs.
     * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramsApi
     */
    public listProgramsForGroup(hashedGroupId: string, options?: AxiosRequestConfig) {
        return ProgramsApiFp(this.configuration).listProgramsForGroup(hashedGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a summary list of Programs the authorized user has started
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramsApi
     */
    public listStartedProgramsForUser(options?: AxiosRequestConfig) {
        return ProgramsApiFp(this.configuration).listStartedProgramsForUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Causes the current user to be sent a sample certificate via email using the current program\'s settings. 
     * @param {string} programUuid UUID of the Program
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramsApi
     */
    public sendSampleCertificate(programUuid: string, options?: AxiosRequestConfig) {
        return ProgramsApiFp(this.configuration).sendSampleCertificate(programUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The POST Module call allows for creation or modification of a Module object and it\'s properties, excluding Parts. In order to add a Part use POST on the parts endpoint. <br/> If the UUID is not provided it will create a Module on this Progam, and if UUID _is_ present it will be updated. 
     * @summary Create or modify a Module
     * @param {string} programUuid UUID of the Program
     * @param {UpsertModuleRequest} upsertModuleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramsApi
     */
    public upsertModuleForProgram(programUuid: string, upsertModuleRequest: UpsertModuleRequest, options?: AxiosRequestConfig) {
        return ProgramsApiFp(this.configuration).upsertModuleForProgram(programUuid, upsertModuleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The POST Progam call allows for creation or modification of a Program object and it\'s properties, excluding Modules. In order to add a Module use POST on the modules endpoint. <br/> If the UUID is not provided it will create a Program, and if UUID _is_ present it will be updated. 
     * @summary Create or modify a Program
     * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
     * @param {UpsertProgramRequest} upsertProgramRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramsApi
     */
    public upsertProgramForGroup(hashedGroupId: string, upsertProgramRequest: UpsertProgramRequest, options?: AxiosRequestConfig) {
        return ProgramsApiFp(this.configuration).upsertProgramForGroup(hashedGroupId, upsertProgramRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StepsApi - axios parameter creator
 * @export
 */
export const StepsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Record user actions for a step, such as starting, or completing the step.
         * @summary Record a user\'s action on a step
         * @param {string} stepUuid UUID of the Step
         * @param {string} hashedGroupId The hash id of the group in which the user is acting
         * @param {StepActionRequest} stepActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptUserStepAction: async (stepUuid: string, hashedGroupId: string, stepActionRequest: StepActionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepUuid' is not null or undefined
            assertParamExists('acceptUserStepAction', 'stepUuid', stepUuid)
            // verify required parameter 'hashedGroupId' is not null or undefined
            assertParamExists('acceptUserStepAction', 'hashedGroupId', hashedGroupId)
            // verify required parameter 'stepActionRequest' is not null or undefined
            assertParamExists('acceptUserStepAction', 'stepActionRequest', stepActionRequest)
            const localVarPath = `/steps/{step-uuid}/action`
                .replace(`{${"step-uuid"}}`, encodeURIComponent(String(stepUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (hashedGroupId !== undefined) {
                localVarQueryParameter['hashedGroupId'] = hashedGroupId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stepActionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a given Step
         * @param {string} stepUuid UUID of the Step
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStep: async (stepUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepUuid' is not null or undefined
            assertParamExists('deleteStep', 'stepUuid', stepUuid)
            const localVarPath = `/steps/{step-uuid}`
                .replace(`{${"step-uuid"}}`, encodeURIComponent(String(stepUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows re-ordering multiple steps at once. All steps must already exist. 
         * @summary Update the order of any number of steps
         * @param {Array<OrderingRequestItem>} orderingRequestItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderSteps: async (orderingRequestItem: Array<OrderingRequestItem>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderingRequestItem' is not null or undefined
            assertParamExists('reorderSteps', 'orderingRequestItem', orderingRequestItem)
            const localVarPath = `/steps/ordering`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderingRequestItem, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The POST Step call allows for creation or modification of a Step object and it\'s properties. <br/> I the UUID is not provided it will create a Step, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Step
         * @param {string} partUuid UUID of the Part
         * @param {UpsertStepRequest} upsertStepRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertStepForPart: async (partUuid: string, upsertStepRequest: UpsertStepRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partUuid' is not null or undefined
            assertParamExists('upsertStepForPart', 'partUuid', partUuid)
            // verify required parameter 'upsertStepRequest' is not null or undefined
            assertParamExists('upsertStepForPart', 'upsertStepRequest', upsertStepRequest)
            const localVarPath = `/parts/{part-uuid}/steps`
                .replace(`{${"part-uuid"}}`, encodeURIComponent(String(partUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertStepRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StepsApi - functional programming interface
 * @export
 */
export const StepsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StepsApiAxiosParamCreator(configuration)
    return {
        /**
         * Record user actions for a step, such as starting, or completing the step.
         * @summary Record a user\'s action on a step
         * @param {string} stepUuid UUID of the Step
         * @param {string} hashedGroupId The hash id of the group in which the user is acting
         * @param {StepActionRequest} stepActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptUserStepAction(stepUuid: string, hashedGroupId: string, stepActionRequest: StepActionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptUserStepAction(stepUuid, hashedGroupId, stepActionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deletes a given Step
         * @param {string} stepUuid UUID of the Step
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStep(stepUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStep(stepUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allows re-ordering multiple steps at once. All steps must already exist. 
         * @summary Update the order of any number of steps
         * @param {Array<OrderingRequestItem>} orderingRequestItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorderSteps(orderingRequestItem: Array<OrderingRequestItem>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorderSteps(orderingRequestItem, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The POST Step call allows for creation or modification of a Step object and it\'s properties. <br/> I the UUID is not provided it will create a Step, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Step
         * @param {string} partUuid UUID of the Part
         * @param {UpsertStepRequest} upsertStepRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertStepForPart(partUuid: string, upsertStepRequest: UpsertStepRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertStepForPart(partUuid, upsertStepRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StepsApi - factory interface
 * @export
 */
export const StepsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StepsApiFp(configuration)
    return {
        /**
         * Record user actions for a step, such as starting, or completing the step.
         * @summary Record a user\'s action on a step
         * @param {string} stepUuid UUID of the Step
         * @param {string} hashedGroupId The hash id of the group in which the user is acting
         * @param {StepActionRequest} stepActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptUserStepAction(stepUuid: string, hashedGroupId: string, stepActionRequest: StepActionRequest, options?: any): AxiosPromise<void> {
            return localVarFp.acceptUserStepAction(stepUuid, hashedGroupId, stepActionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a given Step
         * @param {string} stepUuid UUID of the Step
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStep(stepUuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteStep(stepUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows re-ordering multiple steps at once. All steps must already exist. 
         * @summary Update the order of any number of steps
         * @param {Array<OrderingRequestItem>} orderingRequestItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderSteps(orderingRequestItem: Array<OrderingRequestItem>, options?: any): AxiosPromise<void> {
            return localVarFp.reorderSteps(orderingRequestItem, options).then((request) => request(axios, basePath));
        },
        /**
         * The POST Step call allows for creation or modification of a Step object and it\'s properties. <br/> I the UUID is not provided it will create a Step, and if UUID _is_ present it will be updated. 
         * @summary Create or modify a Step
         * @param {string} partUuid UUID of the Part
         * @param {UpsertStepRequest} upsertStepRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertStepForPart(partUuid: string, upsertStepRequest: UpsertStepRequest, options?: any): AxiosPromise<StepResponse> {
            return localVarFp.upsertStepForPart(partUuid, upsertStepRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StepsApi - object-oriented interface
 * @export
 * @class StepsApi
 * @extends {BaseAPI}
 */
export class StepsApi extends BaseAPI {
    /**
     * Record user actions for a step, such as starting, or completing the step.
     * @summary Record a user\'s action on a step
     * @param {string} stepUuid UUID of the Step
     * @param {string} hashedGroupId The hash id of the group in which the user is acting
     * @param {StepActionRequest} stepActionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StepsApi
     */
    public acceptUserStepAction(stepUuid: string, hashedGroupId: string, stepActionRequest: StepActionRequest, options?: AxiosRequestConfig) {
        return StepsApiFp(this.configuration).acceptUserStepAction(stepUuid, hashedGroupId, stepActionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a given Step
     * @param {string} stepUuid UUID of the Step
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StepsApi
     */
    public deleteStep(stepUuid: string, options?: AxiosRequestConfig) {
        return StepsApiFp(this.configuration).deleteStep(stepUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows re-ordering multiple steps at once. All steps must already exist. 
     * @summary Update the order of any number of steps
     * @param {Array<OrderingRequestItem>} orderingRequestItem 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StepsApi
     */
    public reorderSteps(orderingRequestItem: Array<OrderingRequestItem>, options?: AxiosRequestConfig) {
        return StepsApiFp(this.configuration).reorderSteps(orderingRequestItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The POST Step call allows for creation or modification of a Step object and it\'s properties. <br/> I the UUID is not provided it will create a Step, and if UUID _is_ present it will be updated. 
     * @summary Create or modify a Step
     * @param {string} partUuid UUID of the Part
     * @param {UpsertStepRequest} upsertStepRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StepsApi
     */
    public upsertStepForPart(partUuid: string, upsertStepRequest: UpsertStepRequest, options?: AxiosRequestConfig) {
        return StepsApiFp(this.configuration).upsertStepForPart(partUuid, upsertStepRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SurveysApi - axios parameter creator
 * @export
 */
export const SurveysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Deletes a given survey. This is not allowed if there are surveyResponse objects linked to it.
         * @param {string} surveyUuid UUID of the survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurveyById: async (surveyUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyUuid' is not null or undefined
            assertParamExists('deleteSurveyById', 'surveyUuid', surveyUuid)
            const localVarPath = `/surveys/{survey-uuid}`
                .replace(`{${"survey-uuid"}}`, encodeURIComponent(String(surveyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single survey
         * @param {string} surveyUuid UUID of the survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyById: async (surveyUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyUuid' is not null or undefined
            assertParamExists('getSurveyById', 'surveyUuid', surveyUuid)
            const localVarPath = `/surveys/{survey-uuid}`
                .replace(`{${"survey-uuid"}}`, encodeURIComponent(String(surveyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all responses for a survey
         * @param {string} surveyUuid UUID of the survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSurveyResponsesForSurvey: async (surveyUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyUuid' is not null or undefined
            assertParamExists('listSurveyResponsesForSurvey', 'surveyUuid', surveyUuid)
            const localVarPath = `/surveys/{survey-uuid}/responses`
                .replace(`{${"survey-uuid"}}`, encodeURIComponent(String(surveyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all surveys for a group
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSurveysForGroup: async (hashedGroupId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hashedGroupId' is not null or undefined
            assertParamExists('listSurveysForGroup', 'hashedGroupId', hashedGroupId)
            const localVarPath = `/surveys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (hashedGroupId !== undefined) {
                localVarQueryParameter['hashedGroupId'] = hashedGroupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new survey for a group
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {UpsertSurveyRequest} upsertSurveyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertSurveyForGroup: async (hashedGroupId: string, upsertSurveyRequest: UpsertSurveyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hashedGroupId' is not null or undefined
            assertParamExists('upsertSurveyForGroup', 'hashedGroupId', hashedGroupId)
            // verify required parameter 'upsertSurveyRequest' is not null or undefined
            assertParamExists('upsertSurveyForGroup', 'upsertSurveyRequest', upsertSurveyRequest)
            const localVarPath = `/surveys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (hashedGroupId !== undefined) {
                localVarQueryParameter['hashedGroupId'] = hashedGroupId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertSurveyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save a user\'s completed survey
         * @param {string} surveyUuid UUID of the survey
         * @param {UpsertSurveyAnswersRequest} upsertSurveyAnswersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertSurveyResponseForSurvey: async (surveyUuid: string, upsertSurveyAnswersRequest: UpsertSurveyAnswersRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyUuid' is not null or undefined
            assertParamExists('upsertSurveyResponseForSurvey', 'surveyUuid', surveyUuid)
            // verify required parameter 'upsertSurveyAnswersRequest' is not null or undefined
            assertParamExists('upsertSurveyResponseForSurvey', 'upsertSurveyAnswersRequest', upsertSurveyAnswersRequest)
            const localVarPath = `/surveys/{survey-uuid}/responses`
                .replace(`{${"survey-uuid"}}`, encodeURIComponent(String(surveyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertSurveyAnswersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SurveysApi - functional programming interface
 * @export
 */
export const SurveysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SurveysApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Deletes a given survey. This is not allowed if there are surveyResponse objects linked to it.
         * @param {string} surveyUuid UUID of the survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSurveyById(surveyUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSurveyById(surveyUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a single survey
         * @param {string} surveyUuid UUID of the survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurveyById(surveyUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurveyById(surveyUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all responses for a survey
         * @param {string} surveyUuid UUID of the survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSurveyResponsesForSurvey(surveyUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SurveyAnswersResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSurveyResponsesForSurvey(surveyUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all surveys for a group
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSurveysForGroup(hashedGroupId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SurveyResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSurveysForGroup(hashedGroupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new survey for a group
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {UpsertSurveyRequest} upsertSurveyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertSurveyForGroup(hashedGroupId: string, upsertSurveyRequest: UpsertSurveyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertSurveyForGroup(hashedGroupId, upsertSurveyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Save a user\'s completed survey
         * @param {string} surveyUuid UUID of the survey
         * @param {UpsertSurveyAnswersRequest} upsertSurveyAnswersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertSurveyResponseForSurvey(surveyUuid: string, upsertSurveyAnswersRequest: UpsertSurveyAnswersRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyAnswersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertSurveyResponseForSurvey(surveyUuid, upsertSurveyAnswersRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SurveysApi - factory interface
 * @export
 */
export const SurveysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SurveysApiFp(configuration)
    return {
        /**
         * 
         * @summary Deletes a given survey. This is not allowed if there are surveyResponse objects linked to it.
         * @param {string} surveyUuid UUID of the survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurveyById(surveyUuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteSurveyById(surveyUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a single survey
         * @param {string} surveyUuid UUID of the survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyById(surveyUuid: string, options?: any): AxiosPromise<SurveyResponse> {
            return localVarFp.getSurveyById(surveyUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all responses for a survey
         * @param {string} surveyUuid UUID of the survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSurveyResponsesForSurvey(surveyUuid: string, options?: any): AxiosPromise<Array<SurveyAnswersResponse>> {
            return localVarFp.listSurveyResponsesForSurvey(surveyUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all surveys for a group
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSurveysForGroup(hashedGroupId: string, options?: any): AxiosPromise<Array<SurveyResponse>> {
            return localVarFp.listSurveysForGroup(hashedGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new survey for a group
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {UpsertSurveyRequest} upsertSurveyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertSurveyForGroup(hashedGroupId: string, upsertSurveyRequest: UpsertSurveyRequest, options?: any): AxiosPromise<SurveyResponse> {
            return localVarFp.upsertSurveyForGroup(hashedGroupId, upsertSurveyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save a user\'s completed survey
         * @param {string} surveyUuid UUID of the survey
         * @param {UpsertSurveyAnswersRequest} upsertSurveyAnswersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertSurveyResponseForSurvey(surveyUuid: string, upsertSurveyAnswersRequest: UpsertSurveyAnswersRequest, options?: any): AxiosPromise<SurveyAnswersResponse> {
            return localVarFp.upsertSurveyResponseForSurvey(surveyUuid, upsertSurveyAnswersRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SurveysApi - object-oriented interface
 * @export
 * @class SurveysApi
 * @extends {BaseAPI}
 */
export class SurveysApi extends BaseAPI {
    /**
     * 
     * @summary Deletes a given survey. This is not allowed if there are surveyResponse objects linked to it.
     * @param {string} surveyUuid UUID of the survey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    public deleteSurveyById(surveyUuid: string, options?: AxiosRequestConfig) {
        return SurveysApiFp(this.configuration).deleteSurveyById(surveyUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a single survey
     * @param {string} surveyUuid UUID of the survey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    public getSurveyById(surveyUuid: string, options?: AxiosRequestConfig) {
        return SurveysApiFp(this.configuration).getSurveyById(surveyUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all responses for a survey
     * @param {string} surveyUuid UUID of the survey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    public listSurveyResponsesForSurvey(surveyUuid: string, options?: AxiosRequestConfig) {
        return SurveysApiFp(this.configuration).listSurveyResponsesForSurvey(surveyUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all surveys for a group
     * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    public listSurveysForGroup(hashedGroupId: string, options?: AxiosRequestConfig) {
        return SurveysApiFp(this.configuration).listSurveysForGroup(hashedGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new survey for a group
     * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
     * @param {UpsertSurveyRequest} upsertSurveyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    public upsertSurveyForGroup(hashedGroupId: string, upsertSurveyRequest: UpsertSurveyRequest, options?: AxiosRequestConfig) {
        return SurveysApiFp(this.configuration).upsertSurveyForGroup(hashedGroupId, upsertSurveyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save a user\'s completed survey
     * @param {string} surveyUuid UUID of the survey
     * @param {UpsertSurveyAnswersRequest} upsertSurveyAnswersRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    public upsertSurveyResponseForSurvey(surveyUuid: string, upsertSurveyAnswersRequest: UpsertSurveyAnswersRequest, options?: AxiosRequestConfig) {
        return SurveysApiFp(this.configuration).upsertSurveyResponseForSurvey(surveyUuid, upsertSurveyAnswersRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserAPIsApi - axios parameter creator
 * @export
 */
export const UserAPIsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Record user actions for a step, such as starting, or completing the step.
         * @summary Record a user\'s action on a step
         * @param {string} stepUuid UUID of the Step
         * @param {string} hashedGroupId The hash id of the group in which the user is acting
         * @param {StepActionRequest} stepActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptUserStepAction: async (stepUuid: string, hashedGroupId: string, stepActionRequest: StepActionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepUuid' is not null or undefined
            assertParamExists('acceptUserStepAction', 'stepUuid', stepUuid)
            // verify required parameter 'hashedGroupId' is not null or undefined
            assertParamExists('acceptUserStepAction', 'hashedGroupId', hashedGroupId)
            // verify required parameter 'stepActionRequest' is not null or undefined
            assertParamExists('acceptUserStepAction', 'stepActionRequest', stepActionRequest)
            const localVarPath = `/steps/{step-uuid}/action`
                .replace(`{${"step-uuid"}}`, encodeURIComponent(String(stepUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (hashedGroupId !== undefined) {
                localVarQueryParameter['hashedGroupId'] = hashedGroupId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stepActionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sends an email with a certificate PDF of a given Module for the current user 
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailModuleCertificate: async (moduleUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleUuid' is not null or undefined
            assertParamExists('emailModuleCertificate', 'moduleUuid', moduleUuid)
            const localVarPath = `/modules/{module-uuid}/email-certificate`
                .replace(`{${"module-uuid"}}`, encodeURIComponent(String(moduleUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sends an email with a certificate PDF of a given Program for the current user 
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailProgramCertificate: async (programUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programUuid' is not null or undefined
            assertParamExists('emailProgramCertificate', 'programUuid', programUuid)
            const localVarPath = `/programs/{program-uuid}/email-certificate`
                .replace(`{${"program-uuid"}}`, encodeURIComponent(String(programUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the details of a given Program, including the full hierarchy of dependent objects. This includes only published Programs and Modules 
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchProgramById: async (programUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programUuid' is not null or undefined
            assertParamExists('fetchProgramById', 'programUuid', programUuid)
            const localVarPath = `/programs/{program-uuid}`
                .replace(`{${"program-uuid"}}`, encodeURIComponent(String(programUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return a Module, including the full hierarchy of dependent objects.
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModule: async (moduleUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleUuid' is not null or undefined
            assertParamExists('getModule', 'moduleUuid', moduleUuid)
            const localVarPath = `/modules/{module-uuid}`
                .replace(`{${"module-uuid"}}`, encodeURIComponent(String(moduleUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a summary list of Modules under a given Program.
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModulesByProgramId: async (programUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programUuid' is not null or undefined
            assertParamExists('getModulesByProgramId', 'programUuid', programUuid)
            const localVarPath = `/programs/{program-uuid}/modules`
                .replace(`{${"program-uuid"}}`, encodeURIComponent(String(programUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return a Part, including the full hierarchy of steps it contains.
         * @param {string} partUuid UUID of the Part
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPart: async (partUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partUuid' is not null or undefined
            assertParamExists('getPart', 'partUuid', partUuid)
            const localVarPath = `/parts/{part-uuid}`
                .replace(`{${"part-uuid"}}`, encodeURIComponent(String(partUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return a summary list of Parts under a Module.
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartsForModule: async (moduleUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleUuid' is not null or undefined
            assertParamExists('getPartsForModule', 'moduleUuid', moduleUuid)
            const localVarPath = `/modules/{module-uuid}/parts`
                .replace(`{${"module-uuid"}}`, encodeURIComponent(String(moduleUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single survey
         * @param {string} surveyUuid UUID of the survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyById: async (surveyUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyUuid' is not null or undefined
            assertParamExists('getSurveyById', 'surveyUuid', surveyUuid)
            const localVarPath = `/surveys/{survey-uuid}`
                .replace(`{${"survey-uuid"}}`, encodeURIComponent(String(surveyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return a summary list of Programs the authorized user has access to. This does not include unpublished programs.
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProgramsForGroup: async (hashedGroupId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hashedGroupId' is not null or undefined
            assertParamExists('listProgramsForGroup', 'hashedGroupId', hashedGroupId)
            const localVarPath = `/programs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (hashedGroupId !== undefined) {
                localVarQueryParameter['hashedGroupId'] = hashedGroupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a summary list of Programs the authorized user has started
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStartedProgramsForUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/programs/started`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save a user\'s completed survey
         * @param {string} surveyUuid UUID of the survey
         * @param {UpsertSurveyAnswersRequest} upsertSurveyAnswersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertSurveyResponseForSurvey: async (surveyUuid: string, upsertSurveyAnswersRequest: UpsertSurveyAnswersRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyUuid' is not null or undefined
            assertParamExists('upsertSurveyResponseForSurvey', 'surveyUuid', surveyUuid)
            // verify required parameter 'upsertSurveyAnswersRequest' is not null or undefined
            assertParamExists('upsertSurveyResponseForSurvey', 'upsertSurveyAnswersRequest', upsertSurveyAnswersRequest)
            const localVarPath = `/surveys/{survey-uuid}/responses`
                .replace(`{${"survey-uuid"}}`, encodeURIComponent(String(surveyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertSurveyAnswersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserAPIsApi - functional programming interface
 * @export
 */
export const UserAPIsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserAPIsApiAxiosParamCreator(configuration)
    return {
        /**
         * Record user actions for a step, such as starting, or completing the step.
         * @summary Record a user\'s action on a step
         * @param {string} stepUuid UUID of the Step
         * @param {string} hashedGroupId The hash id of the group in which the user is acting
         * @param {StepActionRequest} stepActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptUserStepAction(stepUuid: string, hashedGroupId: string, stepActionRequest: StepActionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptUserStepAction(stepUuid, hashedGroupId, stepActionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sends an email with a certificate PDF of a given Module for the current user 
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailModuleCertificate(moduleUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailModuleCertificate(moduleUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sends an email with a certificate PDF of a given Program for the current user 
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailProgramCertificate(programUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailProgramCertificate(programUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the details of a given Program, including the full hierarchy of dependent objects. This includes only published Programs and Modules 
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchProgramById(programUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FullProgramResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchProgramById(programUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Return a Module, including the full hierarchy of dependent objects.
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModule(moduleUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModule(moduleUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a summary list of Modules under a given Program.
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModulesByProgramId(programUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ModuleResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModulesByProgramId(programUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Return a Part, including the full hierarchy of steps it contains.
         * @param {string} partUuid UUID of the Part
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPart(partUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPart(partUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Return a summary list of Parts under a Module.
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartsForModule(moduleUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PartResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartsForModule(moduleUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a single survey
         * @param {string} surveyUuid UUID of the survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurveyById(surveyUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurveyById(surveyUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Return a summary list of Programs the authorized user has access to. This does not include unpublished programs.
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listProgramsForGroup(hashedGroupId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SimpleProgramResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listProgramsForGroup(hashedGroupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a summary list of Programs the authorized user has started
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStartedProgramsForUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserStartedProgramResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listStartedProgramsForUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Save a user\'s completed survey
         * @param {string} surveyUuid UUID of the survey
         * @param {UpsertSurveyAnswersRequest} upsertSurveyAnswersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertSurveyResponseForSurvey(surveyUuid: string, upsertSurveyAnswersRequest: UpsertSurveyAnswersRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyAnswersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertSurveyResponseForSurvey(surveyUuid, upsertSurveyAnswersRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserAPIsApi - factory interface
 * @export
 */
export const UserAPIsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserAPIsApiFp(configuration)
    return {
        /**
         * Record user actions for a step, such as starting, or completing the step.
         * @summary Record a user\'s action on a step
         * @param {string} stepUuid UUID of the Step
         * @param {string} hashedGroupId The hash id of the group in which the user is acting
         * @param {StepActionRequest} stepActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptUserStepAction(stepUuid: string, hashedGroupId: string, stepActionRequest: StepActionRequest, options?: any): AxiosPromise<void> {
            return localVarFp.acceptUserStepAction(stepUuid, hashedGroupId, stepActionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sends an email with a certificate PDF of a given Module for the current user 
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailModuleCertificate(moduleUuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.emailModuleCertificate(moduleUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sends an email with a certificate PDF of a given Program for the current user 
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailProgramCertificate(programUuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.emailProgramCertificate(programUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the details of a given Program, including the full hierarchy of dependent objects. This includes only published Programs and Modules 
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchProgramById(programUuid: string, options?: any): AxiosPromise<FullProgramResponse> {
            return localVarFp.fetchProgramById(programUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return a Module, including the full hierarchy of dependent objects.
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModule(moduleUuid: string, options?: any): AxiosPromise<ModuleResponse> {
            return localVarFp.getModule(moduleUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a summary list of Modules under a given Program.
         * @param {string} programUuid UUID of the Program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModulesByProgramId(programUuid: string, options?: any): AxiosPromise<Array<ModuleResponse>> {
            return localVarFp.getModulesByProgramId(programUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return a Part, including the full hierarchy of steps it contains.
         * @param {string} partUuid UUID of the Part
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPart(partUuid: string, options?: any): AxiosPromise<PartResponse> {
            return localVarFp.getPart(partUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return a summary list of Parts under a Module.
         * @param {string} moduleUuid UUID of the Module
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartsForModule(moduleUuid: string, options?: any): AxiosPromise<Array<PartResponse>> {
            return localVarFp.getPartsForModule(moduleUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a single survey
         * @param {string} surveyUuid UUID of the survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyById(surveyUuid: string, options?: any): AxiosPromise<SurveyResponse> {
            return localVarFp.getSurveyById(surveyUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return a summary list of Programs the authorized user has access to. This does not include unpublished programs.
         * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProgramsForGroup(hashedGroupId: string, options?: any): AxiosPromise<Array<SimpleProgramResponse>> {
            return localVarFp.listProgramsForGroup(hashedGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a summary list of Programs the authorized user has started
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStartedProgramsForUser(options?: any): AxiosPromise<Array<UserStartedProgramResponse>> {
            return localVarFp.listStartedProgramsForUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save a user\'s completed survey
         * @param {string} surveyUuid UUID of the survey
         * @param {UpsertSurveyAnswersRequest} upsertSurveyAnswersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertSurveyResponseForSurvey(surveyUuid: string, upsertSurveyAnswersRequest: UpsertSurveyAnswersRequest, options?: any): AxiosPromise<SurveyAnswersResponse> {
            return localVarFp.upsertSurveyResponseForSurvey(surveyUuid, upsertSurveyAnswersRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserAPIsApi - object-oriented interface
 * @export
 * @class UserAPIsApi
 * @extends {BaseAPI}
 */
export class UserAPIsApi extends BaseAPI {
    /**
     * Record user actions for a step, such as starting, or completing the step.
     * @summary Record a user\'s action on a step
     * @param {string} stepUuid UUID of the Step
     * @param {string} hashedGroupId The hash id of the group in which the user is acting
     * @param {StepActionRequest} stepActionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAPIsApi
     */
    public acceptUserStepAction(stepUuid: string, hashedGroupId: string, stepActionRequest: StepActionRequest, options?: AxiosRequestConfig) {
        return UserAPIsApiFp(this.configuration).acceptUserStepAction(stepUuid, hashedGroupId, stepActionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sends an email with a certificate PDF of a given Module for the current user 
     * @param {string} moduleUuid UUID of the Module
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAPIsApi
     */
    public emailModuleCertificate(moduleUuid: string, options?: AxiosRequestConfig) {
        return UserAPIsApiFp(this.configuration).emailModuleCertificate(moduleUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sends an email with a certificate PDF of a given Program for the current user 
     * @param {string} programUuid UUID of the Program
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAPIsApi
     */
    public emailProgramCertificate(programUuid: string, options?: AxiosRequestConfig) {
        return UserAPIsApiFp(this.configuration).emailProgramCertificate(programUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the details of a given Program, including the full hierarchy of dependent objects. This includes only published Programs and Modules 
     * @param {string} programUuid UUID of the Program
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAPIsApi
     */
    public fetchProgramById(programUuid: string, options?: AxiosRequestConfig) {
        return UserAPIsApiFp(this.configuration).fetchProgramById(programUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return a Module, including the full hierarchy of dependent objects.
     * @param {string} moduleUuid UUID of the Module
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAPIsApi
     */
    public getModule(moduleUuid: string, options?: AxiosRequestConfig) {
        return UserAPIsApiFp(this.configuration).getModule(moduleUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a summary list of Modules under a given Program.
     * @param {string} programUuid UUID of the Program
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAPIsApi
     */
    public getModulesByProgramId(programUuid: string, options?: AxiosRequestConfig) {
        return UserAPIsApiFp(this.configuration).getModulesByProgramId(programUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return a Part, including the full hierarchy of steps it contains.
     * @param {string} partUuid UUID of the Part
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAPIsApi
     */
    public getPart(partUuid: string, options?: AxiosRequestConfig) {
        return UserAPIsApiFp(this.configuration).getPart(partUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return a summary list of Parts under a Module.
     * @param {string} moduleUuid UUID of the Module
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAPIsApi
     */
    public getPartsForModule(moduleUuid: string, options?: AxiosRequestConfig) {
        return UserAPIsApiFp(this.configuration).getPartsForModule(moduleUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a single survey
     * @param {string} surveyUuid UUID of the survey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAPIsApi
     */
    public getSurveyById(surveyUuid: string, options?: AxiosRequestConfig) {
        return UserAPIsApiFp(this.configuration).getSurveyById(surveyUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return a summary list of Programs the authorized user has access to. This does not include unpublished programs.
     * @param {string} hashedGroupId The hash id of the group in whose context the user is currently operating
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAPIsApi
     */
    public listProgramsForGroup(hashedGroupId: string, options?: AxiosRequestConfig) {
        return UserAPIsApiFp(this.configuration).listProgramsForGroup(hashedGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a summary list of Programs the authorized user has started
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAPIsApi
     */
    public listStartedProgramsForUser(options?: AxiosRequestConfig) {
        return UserAPIsApiFp(this.configuration).listStartedProgramsForUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save a user\'s completed survey
     * @param {string} surveyUuid UUID of the survey
     * @param {UpsertSurveyAnswersRequest} upsertSurveyAnswersRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAPIsApi
     */
    public upsertSurveyResponseForSurvey(surveyUuid: string, upsertSurveyAnswersRequest: UpsertSurveyAnswersRequest, options?: AxiosRequestConfig) {
        return UserAPIsApiFp(this.configuration).upsertSurveyResponseForSurvey(surveyUuid, upsertSurveyAnswersRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


